var _path, _path2, _g, _g2, _path3, _path4, _path5, _g3, _g4, _path6, _g5, _g6, _path7, _g7, _g8, _path8, _g9;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSv(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "flag-icons-sv",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#0f47af",
    d: "M0 0h512v512H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 170.7h512v170.6H0z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-184.2) scale(.85333)"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M515 353.4c1.5 0 3.2 0 10.1-1.7 7-1.7 12.7-5.9 14-6.5 1.4-.6 3.3-.4 3.3-.4a8.4 8.4 0 0 0-5.8-2.8c-3 0-1.9 0-4.4 1.1-2.6 1-8 4.3-17 4.3h-.1c-9 0-14.7-3.2-17.2-4.3-2.6-1-1.4-1-4.4-1-3 0-5.1 1.9-6 2.7 0 0 2-.2 3.4.4 1.4.6 7.1 4.8 14 6.5 7 1.7 8.6 1.7 10.1 1.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M488.4 347.4c.7-.4-.2-1.6-.2-1.6l2.7-.6c-1.3-.6-3.3-.4-3.3-.4-.5.4-.4.9-.5 1.3 0 .4 0 1 .2 1.3.3.3 1 0 1 0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m491 345.2-2.8.6s.9 1.2.2 1.7l4.8-1-2.3-1.3zm50.7 2.2c-.7-.4.1-1.6.1-1.6l-2.7-.6c1.4-.6 3.3-.4 3.3-.4.6.4.5.9.6 1.3 0 .4 0 1-.3 1.3-.3.3-1 0-1 0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m539.1 345.2 2.7.6s-.8 1.2-.1 1.7l-4.8-1 2.2-1.3z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m495.8 343.3-1.2 3 .6.3c.9.3 1.8.1 2.2-.9.4-1-.1-1.8-1-2.1l-.6-.3zm.3.6c.8.4 1.2.9.9 1.7-.3.8-1 .8-1.7.5h-.1l.9-2.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "m497.6 347.6-.4-.1 1.4-3 .3.1-1.3 3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M500.2 345.3c-.6 0-1.2.4-1.5 1-.4 1 0 1.9.8 2.3.8.3 1.8 0 2.2-1a1.7 1.7 0 0 0-.9-2.2 1.5 1.5 0 0 0-.6-.1zm0 .5h.5c.6.3.8 1 .5 1.6-.2.6-1 1-1.5.7-.5-.3-.8-1-.5-1.6.2-.4.5-.7 1-.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M503.8 347.4c0-.3-.1-.4-.3-.5-.3-.1-.6 0-.7.2l.2.6.3.2c.3.3.5.7.3 1.2a1 1 0 0 1-1.3.6 1 1 0 0 1-.6-1.2h.4c-.1.4 0 .7.4.9.3 0 .6-.1.7-.4.2-.4 0-.6-.2-.8l-.2-.2c-.3-.2-.5-.5-.3-1 .1-.5.7-.6 1-.5.4.2.6.4.7.8h-.4zm2.4.1-.5 1.9c-.1.5-.1 1 .4 1.2.6.1.9-.3 1-.8l.6-1.9.3.2-.5 1.9c-.2.7-.8 1.1-1.5 1-.7-.3-1-1-.7-1.6l.6-2 .3.1zm4.4 4.5-1.8-3-.5 2.4h-.4l.7-3.4 1.8 3 .4-2.4h.4zm.8 0 .4-3.2h.3l-.4 3.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M514.2 348.9a1.6 1.6 0 0 0-1.7 1.6c0 1 .7 1.7 1.6 1.8.8 0 1.6-.7 1.6-1.7 0-.9-.7-1.7-1.5-1.7zm0 .5c.6 0 1 .6 1 1.2a1.1 1.1 0 0 1-1.1 1.2c-.6 0-1.1-.6-1.1-1.3 0-.6.5-1.2 1.1-1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "m519 352.1-2.4-2.3.1 2.4h-.4l-.2-3.4 2.5 2.4-.2-2.4h.4zm2.1-.5-.6-3.2h.4l.6 2.8.9-.2v.4zm1.8-.3-.8-3.2h.4l.7 3.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M523.9 347.7h-.4l-.4.2.9 3.1.7-.1c.5-.2 1-.6.8-1.2-.1-.4-.4-.7-.8-.6l.1-.8c-.2-.5-.5-.6-1-.6zm0 .4c.2 0 .4 0 .5.4.2.4-.1.5-.4.6h-.1l-.3-1h.1a1 1 0 0 1 .2 0zm.5 1.3c.3 0 .6 0 .6.4.2.4-.1.5-.4.6l-.3.1-.3-1h.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "m527.2 348 .2.3-1.2.4.4 1.2 1.2-.5.1.4-1.5.6-1.1-3.1 1.6-.6v.3l-1.1.5.3.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M528.6 346.2c-.3 0-.5 0-.8.2l-.4.1 1.2 3h.3l-.4-1.4 1.4.9.5-.1-1.5-1c.4-.2.6-.7.4-1.1a.9.9 0 0 0-.7-.6zm0 .4.3.3c.2.5-.2.7-.5.8l-.5-1h.1l.5-.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "m529.2 345.8 1.7-.8.2.3-.7.3 1.2 2.7-.3.1-1.2-2.6-.7.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m532.2 344.2.2 3.7.4-.2v-.8l1.3-.7.6.6.4-.3-2.9-2.3zm.4.9 1 .8-.8.5-.1-1.3zm2.7-2.2-1 .3-.5.3 1.7 2.8.5-.3c.9-.5 1.3-1.4.7-2.3-.4-.6-.9-.8-1.4-.8zm.2.5c.3 0 .6.2.8.5.4.8 0 1.3-.6 1.7l-1.3-1.9h.1l1-.3z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "a",
    stroke: "#000",
    strokeMiterlimit: 2.6
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#e60000",
    fillRule: "evenodd",
    strokeWidth: 0.1,
    d: "M485 355.2c.6 0 1-.4 1-1a.9.9 0 0 0-1-.8c-.4 0-.8.4-.8.9s.4.9.9.9zm-5 6.3c.5 0 .9-.4.9-1a1 1 0 0 0-1-.8 1 1 0 0 0-.9.9c0 .5.5.9 1 .9zm-12-19.9c.5 0 1-.4 1-.9a1 1 0 0 0-1-.9.9.9 0 0 0-.8 1c0 .4.3.8.9.8zm-7.3 3.7c.5 0 1-.4 1-1 0-.5-.5-1-1-1a1 1 0 0 0-1 1c0 .6.4 1 1 1zm-1.4-22.3a1 1 0 0 0 1-1c0-.5-.4-1-1-1a1 1 0 0 0-1 1 1 1 0 0 0 1 1zm-6.2 1.8a1 1 0 0 0 1-1 1 1 0 0 0-1-1 1 1 0 0 0-1 1 1 1 0 0 0 1 1zm3.2-19.8a1 1 0 0 0 1-1 1 1 0 0 0-1-1 1 1 0 0 0-1 1c0 .5.4 1 1 1zm-5.5-18.3c.5 0 1-.4 1-1a1 1 0 0 0-1-1 1 1 0 0 0-1 1c0 .6.4 1 1 1zm7 1.8a1 1 0 0 0 1-1c0-.5-.4-1-1-1a1 1 0 0 0-1 1 1 1 0 0 0 1 1zm7-15.2c.5 0 1-.4 1-1 0-.5-.5-1-1-1a1 1 0 1 0 0 2zm-5.3-4.2a1 1 0 0 0 1-1 1 1 0 0 0-1-1 1 1 0 0 0-1 1 1 1 0 0 0 1 1zm10.5-10.3a1 1 0 0 0 1-1 1 1 0 0 0-1-1 1 1 0 0 0-1 1 1 1 0 0 0 1 1zm-21.5 46.3c.6 0 1-.4 1-1s-.4-1-1-1a1 1 0 0 0-1 1c0 .6.5 1 1 1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.3,
    d: "M486 358.9s-.8-3.2-.7-3.9l.8-.6m-1.4 5.7s-2.8.1-3.7.4l-.3.8m-13.4-15.5s-.2-3.8.6-4c0 0 .7-.4 1.2-1m-4.7 3.8s-2.1-.3-2.7 0c0 0-.2.6-.6.8m-.8-23-.7.5c-.8.3-2.3 4-2.3 4s-2.4-1.9-3.4-2h-1.1m-4.8-20.2s.6.6 1.2.3c0 0 3 2 3.1 2.7 0 0 3.2-3.2 3.8-2.9 0 0 .3.5 1-.1m-5.8-18.6s.3.5.9.8c0 0 1.4 2 1.4 3.5 0 0 2.5-2.3 3.3-2.1 0 0 .9.3 1.5 0m.3-19.5s.6.8 1 .2c0 0 1.8 2.2.8 4 0 0 2.5-.7 3.3-.3 0 0 .3 1 1.2.5"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#1f601a",
    fillRule: "evenodd",
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "m532.8 378.3-4.5-.3c-.6 0-2-2.7-2.6-3.1-.6-.5-10.8-5.5-17.5-6.5a95 95 0 0 1-19-6 88 88 0 0 1-26-19.2c-2.9-4.2-6-14-7.2-19.2-.7-2.5-4-12.4-4-19.2a84 84 0 0 1 2.2-19.4 111 111 0 0 1 15.3-26.8s-12 18.7-14.2 25.9a81 81 0 0 0-2.5 21.5c.1 4.2 3.6 19.6 8.7 30.9 4.1 9 7.7 10.2 14 15.2 3 2.4 8.8 6.2 13.6 8.6 4.8 2.4 15 5.5 17.8 5.9 2.7.5 16.4 4.5 18.2 5.4 1.8 1 6.5 5 7.7 6.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M464.1 343.4c.3-1.4.4-2.4 1-2.8a14 14 0 0 0 2.2-3.5c.3-1.2 0-2.2 0-2.8l.4-2.7s-.7-2.5-1.3-3c-.6-.4-2.2-2.6-2.5-3.2 0 0 .2 1.3-.3 1.9a7 7 0 0 0-.6 3c0 .9.3 3 0 4-.3 1.2-.7 2.2-.4 3.5l1.5 5.6zm-.5-1.5s-3.4-4.4-3.4-6.2c0-1.8-.3-2.9-.6-3.3-.3-.4-2.3-2.7-.5-5.6.8-1.2 1-1 1.4-2.4.6-1.6 1.8-1.6 2-3.3 0 0 .4 2 .5 3.6.2 1.7-.1 2.3-.2 3.2-.2.9.4 2 .4 3.3 0 1.4-.2 1.9-.2 2.7 0 .4-.5 6.2.6 8zm38.6 23.5-4-.5c-.7 0-2.5-.5-3.5-.9a10 10 0 0 1-4-2.8c-2.8-3-2.5-4.5-3-4.6-1-.2 1.5-.4 2.8-.3 1.1.2 2.8 1 3.8 2 1.2 1.1 3 2.3 3.5 2.7.6.5 1 .7 1.7 1.5.7 1 .6 1.5 2.7 3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M506.2 367.5s-7.2-3.2-8-3.8a25 25 0 0 1-2.8-2.6c-.7-.8-3.8-2.4-4.3-3.4-.3-.7-2.3-3.3-3.4-5.4-.5-1 4.9.3 4.9.3 4.4 1.8 2.4.6 4.8 2.4 1.5 1.1 2.5 2 2.9 2.9.6 1.3 1.2 3.5 1.9 4.7.6 1.2 1.7 2.7 4 5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M510.2 368.4s-6-1.5-8.8-5.2c-2-2.6-2-1.8-2.7-2.7-1-1-2.6-2.3-4-4.5.2.3-1.6-5.9-1.6-6.6 0-.4 2.3.3 4.2 1 1.5.7 2.4 2 3.8 2.8 1.6 1 1.8 3.7 2.5 4.9 1 1.8 1.2 2.7 1.2 3.5 0 1.4.8 1.8 1.2 3 .5 1.3 2.1 1 4.2 3.8zm-9.6-2-5.9-2.4c-.8-.1-1-.6-2.1-.9-.9-.2-1.7-.9-3.8-.4-.9.2-4.6 1-5.5.6-1-.5 1.3 2.5 2.3 3.1 1.1.7 2.9 1 4.4.8h4.4c.7 0 1.2.2 2.3-.1 1-.3 1.3-.8 3.9-.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M504 366.4s-5.7-1.4-6.7-1.4l-4.8.4c-1 .2-4.5-.2-5.5.4-1 .4-5.6 1-6.8.8-1.2-.3 2.4 3.2 3.9 3.6 4.6 1.3 3.2 1.1 6.2.4 1.8-.5 4.4-.6 5.4-.8.9-.1.7-.7 2-1.2 1.1-.5 3.2-1.8 6.3-2.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M508.7 368.8s-5.7-2.4-10.2-1.1l-4.2 1c-1.4.1-2.6-.6-5 .4-1.2.4-6.2 2.5-7.5 2.4-1.3-.1 4 3.3 5.4 3.1 4.6-.6 9 1 11 0l4-1.5c1-.4 1.5-1.2 2.1-1.7.6-.4 1-1.6 4.4-2.6zm-30.6-13.1s-3.3-3.6-4-4.1l-3-2.4c-.6-.6-1.3-2-3.4-2.5-1-.2-3.1-.6-3.8-1.4-.6-.8.1 3 .8 4a8.1 8.1 0 0 0 3.6 2.5c1.5.5 3.3 1.5 4 1.9.6.3 1 .6 2 .8 1.1.2 1.6 0 3.8 1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M481.3 357.2s-5.7-4-6.5-4.4l-3.5-1.3c-1.1-.3-4-2.3-5-2.3-1.2 0-3.3-.1-4.3-.8-1-.8-.1 2.7 1 3.7 3.6 3.2 1.1 2.2 4.1 2.8l5.1 1.7c1 .3 1-.3 2.3-.2 1.3 0 3.8-.2 6.8.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M482.6 358.3s-2.3-1.6-6.9-2.4c-3-.5-3-.6-4.1-1-1.4-.4-1.7-.4-4.3-.5-1.2-.1-6.2 1.5-7.4.8-1-.6 1.3 1.5 2.6 2 2 .8 1.8 2 4 2.8 2.2.7 4.7 1.6 6 1.4 1-.2 1.8-.7 3.3-.8 1.4-.2 4-2.3 6.8-2.4zm.5-1.2s1.1-5.5.1-6.8a5.2 5.2 0 0 1-1.2-2.9 11 11 0 0 0-1.6-4.3c-.6-.8-1.8-4.2-1.5-5.1 0 0-3.2 3.1-3 5.1v2.4c-.2.9.7 3.9 1.3 4.8.6 1 .3 3.6 1 4.2.5.6 4.1 3 4.9 2.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M482.6 358.3c.3.1-2-1.8-3-2.3-1-.4-5.3-1.6-5.6-2.7-.3-1-3.7-4.6-3.9-5.6 0-.6-.7-2-.6-2.8.2-.7.5-2.6 1-3.6.4-1.1 1.4-3.6 2.5-4l1.2 3.8c.3 1 .6 2.3 1 2.9.5.6 2 3.4 2.1 4.5l1.1 5.3c.1.7 3 3.8 4.2 4.4zM464 343.4c.1.8-2.3-.8-3.5-.8-1.2 0-4.8.5-5.7-.4-.9-1-2.2-2.6-2.7-2.9-.5-.3-2.1-3-2.6-4.5-.4-1.5-3.6-4.2-4-4.5 0 0 4.3-.9 7 .9s3 1.4 3.5 1.6c.6.3 5.3 4.3 5.6 5.8.3 1.5 2.2 4 2.4 4.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M464.1 343.4s-3.9-2.7-4.8-2.6c-1 .2-5.2-3-5.4-5-.2-1-2.2-2.5-2.6-3.1-1-1.8-1.7-5.9-3.2-7l5.2 1.3c2 .3 3.6.6 4.3 2.2.8 1.7 1.4 3 2 3.2.6.2 1.5 2.3 1.8 4.4a32 32 0 0 0 2.7 6.6zm-7.4-20.5c.7 1 .6-6 .9-6.8a11.3 11.3 0 0 1 1.7-2.8c.6-.6.6-2.7.9-3.3.3-.6.1-4.7-.3-5.8L458 306c-.6.7-1.7 1-2 2-.3.8-.9.8-1.3 1.8a5.6 5.6 0 0 0-.6 3.6c.3 1.2.1 1.6.1 2.7 0 1 1.5 5.6 2.4 6.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456.9 323.5s-.3-2 .4-2.7c.8-.8 1.5-.8 1.8-1.2.3-.5.2-1 .5-1.7.3-.6 1-1.6 1-2 .3-1.7 1.3-3.6.5-5.3 0 0-1.7.5-2.1.8-.5.3-1.8 1.6-2 2.8-.1 1.3-.3 1.5-.7 2.2-.5.8-1 3-.3 4.4a7.4 7.4 0 0 1 .9 2.7zm-4.4-23s-.3-4.4.9-5.8c1.2-1.3 1.5-3.9 4.2-5.3v1.9c.2.7.5 2.8 0 3.6-.4.7-2 2-2 2.7 0 .6-1 2.1-1.7 2.4l-1.4.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M452.5 302.8s0-3 .9-4c.9-.9 1.4-1.4 1.8-2 .5-.5 1-2 2-2.7 1-.6 2.8-2.1 3-2.7 0 0 .4 3.8-.6 5.8s-1 3-2.3 3.4c-1.2.5-1.4.8-1.8 1-.5.4-1.2.8-1.8.8-.6 0-1.2.4-1.2.4zm3.5 20.6c.1.8.7-2-2.4-2-3.2 0-5.8-1.2-6.8-2.3l-2.1-2.3a9 9 0 0 1-1.8-3.1c-.2-.9-1-4.2-1-4.8 0 0 1.7.3 2.5.9.7.6 2 .6 2.8 1 .8.5 1.4 1.7 1.9 2.1.4.5 1.7.5 2.3 1.4.6.9 1.7 2.9 1.9 3.8 0 .9 1.2 1.8 2 2.2.6.5.5 2.3.6 3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M455.6 322.1s-2-2.5-3.1-2.5c-1 0-3.8-2.7-4-4 0-1.1-1-3.4-1.6-3.9a3.6 3.6 0 0 1-1.5-3.3c.2-1.8.2-4.8.2-4.8s.6 1.8 1.5 2.3c.9.4 2.5 1 2.8 1.6.3.6 1.5.6 2 2.5.5 1.7.5 1.6.8 2.2.3.6 1 1.4 1.3 2.6.3 1.2 2 4.3 1.7 7.3zm-3-16.6c-.2.8 1.1-1.6-1.7-2.4a9.6 9.6 0 0 1-5.6-4l-1.3-2.6a9 9 0 0 1-.7-3.4c0-.9.2-4.1.5-4.6 0 0 1.4.7 2 1.4.4.8 1.7 1.2 2.3 1.8.5.6.7 1.9 1 2.5.3.5 1.5.9 1.8 1.8.3 1 .7 3.1.6 4-.1.8.6 2 1.2 2.6.5.6-.1 2.2-.2 3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M452.6 304.3s-1.3-2.9-2.2-3.2c-1-.3-2.5-2.7-2.6-3.9-.1-1.2-.3-3.4-.7-4-.5-.6-1.3-2.4-.6-4l1.6-3.7 1.3 2.1c.8 1.6 1.6 1.7 1.7 2.3.1.7 1 1 1.4 2.3.5 1.7 0 1.6 0 2.3.2.6.7 1.5.6 2.7 0 1.1.6 4.5-.5 7.1zm2.3-18.2c.1-.4 1-.9 2.1-1.2 1-.3 2.7-2.7 3.5-3.3.7-.6 1-1.6 2-2.1.9-.5 1.4-2.4 1.7-4.2l-3.3.7a7.2 7.2 0 0 0-2.8 1.8c-.6.8-1.2 2-1.9 2.3-.6.3-1.3 2.1-1.3 3.3v2.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m454.8 284.8-.2-2.6c0-.9-.6-3.3.7-5.3 1-1.3 4.3-3.9 5.2-4 0 0 .6 2.4.4 3.1-.1.8-1 3.8-1.6 4.1-.7.3-2.4 3.9-4.5 4.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M454 286.1c-.4.7-.1-2.2-1-3-1-.7-1-1.8-1-3s.2-2 .3-2.9c.2-.7 2.5-3.9 2.3-4.8l1.7 3.8c.4 1-.3 2.1-.2 3 .2.9.9 2.6.3 3.5L454 286zm8-15.5s.2-.4 1.5-.4 3.3-.1 3.9-.8c.6-.6 1.6-1.4 2.3-1.7a5.2 5.2 0 0 0 1.8-2.2c.1-.6 1.2-1.8 1.6-1.8 0 0-1.6-.2-3.4.3-1.8.5-4.4 1.4-5 2.6-.6 1.2-2.7 4-2.7 4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M462.5 270.3c.3 1 2.8-1 3.4-1.8l1.5-2 1.8-2.4c1-1.6.7-4.6.3-4.3a31 31 0 0 1-2.5 1.4c-.5 0-1.4.4-1.7 1.1-.3.8-.6 1.8-1 2.3-.5.5-3.2 2-1.8 5.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461.6 270.3s2-1.5 2.8-2.3c1-.8.5-2 1-2.6.3-.6 1.4-2 1.1-3l-.9-3.4-1.8 1.8c-.8.8-.9 1.4-1.2 2.3-.3.9-1 1.5-1.2 2.2-.3.8 0 2.3.2 3.2v1.8z"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    strokeWidth: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M494.8 365.2s-10-.1-10.8-1.3m16.6 2.6s-6.5 1.7-10 1.3c-3.5-.4-5.1.3-5.9.3-.7 0-4.5-1.5-4.5-1.5m27 2.2-6 1.3c-1 .3-6.2 2.2-7.7 2.2h-5a18 18 0 0 1-6.3-.4m6.2-15s3.7 2.3 4.4 3c.5.8 3.8 3.5 4.5 3.5m-9-11.1s6.5 5.6 7.6 6.3c1 .8 7.4 7 8.1 7.8M493.6 350s5.1 4 5.7 5.7c.6 1.7 2.2 3.6 2.2 3.6s2 4.2 2.8 4.8c.8.6 2.3 2.2 4.1 3.4m-44-21.3s5.4 4.6 6.9 5.4m-9.1-2.5s5.4 3.7 7.8 4.6c2.4 1 4.4 1.7 9.6 2.4m2.1 2.2s-6-.3-7 0-5.8-.8-7-1.1l-6.6-1.4m11.4-17.9s-.3 3.3.2 4.7c.4 1.3 2.6 5.3 2.4 6.2-.1.9 1.2 5 2.4 5.7m1.2-16s-1 3.3-.6 4.4c.5 1 1.2 3 1.2 4.2 0 1.2.8 3 1 3.8.4.7-.1 3.3.7 4l1.6 2.2m-36.1-26.3s4.8 1.9 5.4 3c.6 1.3 1.5 1.6 2 2.2m10.3-9.7s1.3 4.9 1 6c-.3 1.2-.3 3.7-.3 4.6 0 .9-1.4 4.5-1.3 5m-1.3-19.6-.6 4c-.1 1.2 0 3.2-.3 4-.3.7-.8 4.8 0 6.6M449 326.2l4.8 4.2c.9 1 5 5.3 5.1 6.4.1 1 3 4.3 3.9 5m-20.5-32.5s4 4 4.2 4.9c.3.9 2 2.3 2.8 2.8m11.4-6s-1.5 2.3-1.5 3c0 .8-.6 2.7-1.2 3.5-.4.5-1.7 2.7-1.5 4m3-16.8-1 3.6c-.2 1.5-1 3-1.3 4-.3.8-1.5 5.2-1 7.9m-10.4-15.7s.4 2.1 1.5 3.2c1 1 2.7 2.6 2.8 3.4.2 1 1.6 5.4 3 7a5.4 5.4 0 0 1 1.7 3m-10.5-32s.4 2.6.7 3.4c.3.7 1.5 4 2.7 5.1m9.5-7.7-.9 3c-.1 1-1 2-1.2 2.4l-.7 2m5.5-5.3c-.1.9-1.8 3.6-2 4-.1.5-1 2.6-1.9 3.2-.9.6-3.6 2.6-3.4 3.4m-4.4-16.5s-.2 3.3.4 4.5a37.2 37.2 0 0 1 1.7 4c.3.9.3 2.4.4 3.4.2 1.1.6 3 1.2 3.8m11.8-25.9-3.2 3.5c-1 1-4.8 5-5 5.8m4.6-11.6s-2.1 4.7-2.6 5.4l-.9 2m-2-7.5s.2 3.6 0 4.5a7.9 7.9 0 0 0 0 2.9c.2.4-.4 3.7-.5 4.5m18-21.3s-4.8 2.9-5.5 3.6m2.7-7.3-3.3 4.8-.8 1.4m.3-6.7s-1 2.6-1.2 3.6a36 36 0 0 1-2.2 5.6"
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 0.3,
    d: "M469.2 258s-.4 1 1.4.7"
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a",
    width: "100%",
    height: "100%",
    transform: "matrix(-1 0 0 1 1030 0)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00209f",
    fillRule: "evenodd",
    d: "M514.6 366.1s.7-1.8 2.2-.1c0 0 1.9 4.2.5 4.3-1.4.2-2.7.5-2.9-.3-.1-.7.2-3.9.2-3.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00209f",
    fillRule: "evenodd",
    d: "M516.5 365.5s.5-6.4 1.4-6.7c.9-.3 3.6-1.8 5.3-.5 1.6 1.4 0 8-.5 8.7-.6.6-1.5 2.5-5 2l-.4-1.6s1.8-.2 3-.8c1.2-.6 1.6-1.2 1.5-1.8-.2-.9 0-4.2-1-4.5l-2.3-.8-1.7 6.5-.3-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00209f",
    fillRule: "evenodd",
    stroke: "#000",
    strokeMiterlimit: 2.6,
    strokeWidth: 0.2,
    d: "M514.4 370s-6.2 3.7-3 9l-2.1-1.3s-1.2 2.2-.1 3.4c0 0-4.3-3.8-1-8.3 3.4-4.6 6-4.3 6-4.3l.2 1.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00209f",
    fillRule: "evenodd",
    stroke: "#000",
    strokeMiterlimit: 2.6,
    strokeWidth: 0.2,
    d: "M514.4 367s-2.7-1.8-6.6-.7c0 0-1.7-5.6-1-7.4.2-.8.8-.9.8-.9s-2-1.2-1.3 4c.6 5.4 1.6 6.8 1.6 6.8s5.2.3 6.4-.3l.1-1.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00209f",
    fillRule: "evenodd",
    stroke: "#000",
    strokeMiterlimit: 2.6,
    strokeWidth: 0.2,
    d: "M514.4 367s-5.4-9-6.8-9c0 0-1.5-.2 2-.6 1.2-.1 3.2 0 4 1.7 1 1.6 1.7 5.5 2 6.1 0 0-1 .3-1.2 1.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#011322",
    fillRule: "evenodd",
    stroke: "#000",
    strokeMiterlimit: 2.6,
    strokeWidth: 0.2,
    d: "M514.4 367s-3.6-1.6-4-2c-.5-.5-1.2-5.6-.8-5.3 0 0-1.5-1.7-2-1.7-.3 0-1.3.8-1 2.6.3 1.8.7 4.5 1.2 5.7 0 0 2.9-1.2 6.6.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00209f",
    fillRule: "evenodd",
    stroke: "#000",
    strokeMiterlimit: 2.6,
    strokeWidth: 0.2,
    d: "M517.7 370s2 1.3 2 3.5c0 2.3.9 6.4 2.7 7.3 0 0 .5-1.7 1-2 0 0 1.9 2.1 2.5 2.1 0 0-1-2-1-2.9 0-.9-1-4.3-2-5.2-.8-1-2.6-3-5.2-3.8v1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#011322",
    fillRule: "evenodd",
    stroke: "#000",
    strokeMiterlimit: 2.6,
    strokeWidth: 0.2,
    d: "m518.5 359.5-1.7 6.5.5 1.4s.6-.2.9-1c.3-.7 1.2-6.3 1.7-6.5l-1.4-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#011d33",
    fillRule: "evenodd",
    d: "M514.4 369.3s-3 1-4.1 3.2c0 0-.4-1.5 4-3.6v.4zm3.4 0s2 .8 2.6 2l-2.6-1.5v-.5zm-3.4-1.7s-4.6.7-5.6.5c0 0 1.3.3 5.6 0v-.5zm7.4-2.8s.5 2.3.9 2.2c.4-.2 1.2-3.9 1.2-5.6 0-1.7-.7-2.1-1.4-2-.7 0-1 1.5-1 2.2a49 49 0 0 0 .3 3.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#011d33",
    fillRule: "evenodd",
    d: "M516.8 366s1.9 4.1.5 4.4c-1.4.2.6.1-.4-2.7-.4-1.1-1-2.5-1.3-2.5 0 0 1.1.4 1.2.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 2.6,
    strokeWidth: 0.2,
    d: "M514.6 366.1s.7-1.8 2.2-.1c0 0 1.9 4.2.5 4.3-1.4.2-2.7.5-2.9-.3-.1-.7.2-3.9.2-3.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 2.6,
    strokeWidth: 0.2,
    d: "M516.5 365.5s.5-6.4 1.4-6.7c.9-.3 3.6-1.8 5.3-.5 1.6 1.4 0 8-.5 8.7-.6.6-1.5 2.5-5 2l-.4-1.6s1.8-.2 3-.8c1.2-.6 1.6-1.2 1.5-1.8-.2-.9 0-4.2-1-4.5l-2.3-.8-1.7 6.5-.3-.5z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-184.2) scale(.85333)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#00209f",
    fillRule: "evenodd",
    d: "M509.8 255.9c-.4-1-.4-7.4-.4-8.4a68 68 0 0 1 3.8-11.2c.6-1 .5-1.2.7-1.8l.9-1.2a10.9 10.9 0 0 1 1.3 4.1s-.6 4.1-1.1 6c-.4 1.7-1.6 4.3-1.8 4.8-.6 1.2-.5 2.4-.2 2.5l-3.2 5.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "m515 247.3.5.6c1.3-1.5 1.4-4.5 1.4-4.5l-.9-6s-.5 4-1 6c-.4 1.7-1.6 4.3-1.8 4.8-.9 2.2-.2 2.4-.2 2.5l2-3.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00209f",
    fillRule: "evenodd",
    d: "M515.5 247.9c1.3-1.5 1.4-4.5 1.4-4.5s1 5 .4 6c-.5 1-.5.7-.4 1.3l-1.4-2.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 2.6,
    strokeWidth: 0.3,
    d: "M517 250.7c-.2-.6-.2-.3.3-1.3s-.4-6-.4-6l-.9-6c0-1.3-.6-3-1.2-4.1l-.9 1.2c-.2.6 0 .8-.7 1.8-.6 1-3.6 9.5-3.8 11.2 0 1 0 7.5.4 8.4"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fc0",
    fillRule: "evenodd",
    stroke: "#000",
    strokeMiterlimit: 2.6,
    strokeWidth: 0.1,
    d: "m515 234.1-.2-1.3c0-.2.6.9 1 .7.9.3 1.9 1.5 2.1 1.8-.4.5-1.3 1.6-2 1.4-.5-.2-.4-1-.5-1.5-.1-.3-.4-.6-.4-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 2.6,
    strokeWidth: 0.1,
    d: "m515 233.3.4.4c.2.2.4 0 .7.2.6.4.9.8 1.6 1.5m-2-1.4c.8.4 1.2 1 1.8 1.7"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fc0",
    fillRule: "evenodd",
    stroke: "#000",
    strokeMiterlimit: 2.6,
    strokeWidth: 0.1,
    d: "m514 233.4 1.3-.6c.1 0-.7.8-.4 1.2 0 .9-.7 2.2-1 2.5-.6-.1-1.2-.1-1.8-1.1-.2-.4.4-.8.8-1.1.2-.2.7-.8 1.2-.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 2.6,
    strokeWidth: 0.1,
    d: "m514.9 233.2-.3.5.1.7c-.2.7-.5 1-.9 2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 2.6,
    strokeWidth: 0.1,
    d: "M514.4 234c0 .9-.5 1.5-1 2.3h.2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fc0",
    fillRule: "evenodd",
    stroke: "#000",
    strokeMiterlimit: 2.6,
    strokeWidth: 0.1,
    d: "M515.4 232.8c.6-.7 1.7-1.4 2.3-1l.6.6c.2.3.2.5 0 .8-.3.8-1.4.4-2 0-.2 0-.6-.4-.8-.3l-.3.1.3.1 1.8.9c.5.2 1.5-.5 1.4-1 0-.5-.9-1.5-1.3-1.5-1 0-1.8.6-2.5 1.4.2-.2.4 0 .5 0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fc0",
    fillRule: "evenodd",
    stroke: "#000",
    strokeMiterlimit: 2.6,
    strokeWidth: 0.1,
    d: "M514.9 232.8c-.6-.7-1.7-1.4-2.2-1l-.6.6c-.3.3-.3.5-.1.8.3.8 1.4.4 2 0 .2 0 .6-.4.8-.3l.4.1-.4.1-1.8.9c-.5.2-1.4-.5-1.4-1 0-.6 1-1.5 1.4-1.5 1 0 1.7.6 2.4 1.4-.1-.2-.4 0-.5 0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fc0",
    fillRule: "evenodd",
    stroke: "#000",
    strokeMiterlimit: 2.6,
    strokeWidth: 0.1,
    d: "M515 232.4c-.2-.1-.5.1-.6.3 0 .2.1.6.4.6.3.2.8 0 .9-.3 0-.4-.3-.5-.6-.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fc0",
    fillRule: "evenodd",
    d: "M515 226.3s.4 2.4 1.6 4c1.2 1.8-1.4 1.6-1.6 2.2 0 0-.8-1.7-1.6-2.2 0 0 1.3-2 1.6-4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 2.6,
    strokeWidth: 0.1,
    d: "M515 226.3s.4 2.4 1.6 4c0 0-1.4 1.6-1.6 2.2 0 0-.8-1.7-1.6-2.2 0 0 1.3-2 1.6-4"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 2.6,
    strokeWidth: 0.1,
    d: "m515 228.8.7 1.8s-.6.4-.7.7c0 0-.3-.8-.6-1 0 0 .6-.8.6-1.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "m515 344.5-.3-.2c-.4-.2-1.2-.2-1.3-.5-1-1.1-.4-3.4 0-4.8 1-2.6 1-5 1.6-7.4.6 2.4.7 4.8 1.6 7.4.4 1.4 1.1 3.7.1 4.8-.2.3-.9.3-1.3.5l-.4.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00209f",
    fillRule: "evenodd",
    d: "M515 331.5c.6 2.5.7 5 1.6 7.6.4 1.3 1 3.4.3 4.5.4 0 .7-.1 1-.3.2 0 .3 0 .4-.2l.4-.5c.3-.2.6 0 .9-.2l.1-.2c.6-.3 1-.6 1.3-1.1.1-.4.2-.9 0-1.3 0-.3 0-.5-.2-.8l-.5-1.1-.6-1.2a2.4 2.4 0 0 0-.3-.5l-.3-.6-.4-.4-.4-.3s-.3-.1-.2-.2l-.3-.1-1-2a3 3 0 0 1-.2-1.1H515zm0 0c-.5 2.5-.7 5-1.6 7.6-.3 1.3-1 3.4-.2 4.5-.4 0-.7-.1-1.1-.3-.1 0-.3 0-.3-.2a1.4 1.4 0 0 0-.5-.5c-.2-.2-.5 0-.8-.2l-.2-.2c-.5-.3-1-.6-1.2-1.1a2.5 2.5 0 0 1-.1-1.3l.2-.8.6-1.1.6-1.2c0-.2.1-.4.3-.5l.3-.6.4-.4.4-.3.2-.2.2-.1 1-2c.2-.2.2-.8.2-1.1h1.6z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "b",
    fill: "none",
    strokeMiterlimit: 2.6,
    strokeWidth: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#011322",
    d: "M514.3 331.6s-1 4-1.6 5c-.6 1.1-3 3-1.4 6"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#011d33",
    d: "M514.4 331.6s-1 4-1.6 5.1c-.6 1.1-3 3-1.4 6"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#022743",
    d: "M514.5 331.6s-1 4.1-1.6 5.2c-.6 1-2.9 3.1-1.3 6"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#033054",
    d: "M514.6 331.6s-1 4.2-1.6 5.3c-.6 1-2.9 3-1.2 6.1"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#053a65",
    d: "M514.7 331.6s-1 4.3-1.6 5.3c-.6 1-2.8 3.2-1.2 6.3"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#011d33",
    d: "M514.2 331.6s-1 4-1.6 5c-.6 1.1-3 3-1.4 6"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#022743",
    d: "M514 331.6s-.9 3.8-1.6 5c-.6 1-3 3-1.4 5.9"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#033054",
    d: "M514 331.6s-1 3.7-1.7 5c-.5 1-3 3-1.4 5.9"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#053a65",
    d: "M513.8 331.6s-.8 3.6-1.6 5c-.6 1-3 3-1.4 5.9"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#00209f",
    d: "M513.8 331.6s-.9 3.4-1.7 5c-.6 1-3 2.9-1.4 5.8"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#00209f",
    d: "M514.8 331.6s-1 4.3-1.6 5.4c-.6 1-2.8 3.3-1.1 6.3"
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b",
    width: "100%",
    height: "100%",
    transform: "matrix(-1 0 0 1 1030 0)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 2.6,
    strokeWidth: 0.2,
    d: "m518.6 335.2.5.5.3.5.3.5.6 1.2.5 1.1.3.8a2.5 2.5 0 0 1-.1 1.3c-.2.5-.8.8-1.3 1.1l-.1.2c-.3.2-.6 0-.9.2a1.9 1.9 0 0 0-.4.5l-.3.2c-.4.2-.7.3-1.1.3l-.2.3c-.2.2-1 .2-1.3.4l-.4.2-.3-.2c-.4-.2-1.2-.2-1.3-.4a.7.7 0 0 1-.2-.3l-1.2-.3s-.2 0-.3-.2a1.4 1.4 0 0 0-.4-.5c-.3-.2-.6 0-.8-.2l-.2-.2c-.6-.3-1-.6-1.2-1.1a2.5 2.5 0 0 1-.1-1.3l.2-.8.5-1.1.7-1.2c0-.2.1-.4.3-.5 0-.2.1-.4.3-.5 0-.2.3-.3.4-.5"
  }), /*#__PURE__*/React.createElement("g", {
    id: "c"
  }, /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M487.4 293.6c-1.5-3.7-3-11.3-3-13 .3-7.1.2-9.3.9-16.5l7.3 8.3c-.2 2.8-.2 3.7 0 5.5.1.7.5 3.9 1 5.1l-6.2 10.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00209f",
    d: "M493.6 283c-.5-1.3-.9-4.5-1-5.1-.2-1.8-.2-2.7 0-5.5l4.5 5-3.5 5.6zm-18.6 7a75.6 75.6 0 0 1-.3-4.4c0-5.1-.6-8 0-13.4.4-4.2 1.5-9.8 1.3-14.4-.1-1.3.1-2.6.2-3.9l9 10.1c-.6 7.3-.5 9.5-.8 16.6 0 1.7 1.5 9.3 3 13l-2 3.2-10.4-6.9zm6.3 13.7c-.6-1-1-3.9-1.2-4.5-.3-1.5-.3-2.3-.2-5l5 3.3-3.6 6.2zm-14.3 24a5.2 5.2 0 0 1-1.8-2.2c-.7-1.8-.5-1.7-1-3.6-.2-1.1-.2-2.3-.5-3.4-.2-1.2-1.8-4.8-1.8-6.2-.2-4.8-1.8-8-1.4-13.2.3-4 1.2-9.4.7-13.5l.1-3.6 10.3 6.7c-.4 6.8-.2 8.8-.2 15.4 0 1.6 1.3 8.1 3 11l-7.4 12.6zm17 3.8c1.9 1.7 5.4 2.6 6 3 1.2 1 3 2.3 6.3 2.4 2.3.2 3.3-.4 5.7-.7 2.8-.3-.3.1 2.3-.5 1.4-.3 1.4-.5 3.2-1 1.3-.3 2.7-.6 3.5-1.8.3-.4.6-.7.6-1.4h1.8c.2.5-.3 1.5-.5 1.8l-.5.7c-.2.6-.2.4-.7.9l-.8.6c-.4.3-.7.6-1.1.7-1.8.3-2.5.7-4.2 1.1-1.6.5-.7.4-2 .7l-2.4.7-2.4.6c-2.9.7-5.7.5-8.6.3-1.1 0-4-.7-5-1.4-1.8-1.2-5.7-1.7-7.4-2.9-.3-.2-1.4-.7-1.6-1-1.7-1.3-3-1.7-4.8-2.8H484z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00209f",
    d: "M497.7 331.5h14c-.1.7-.4 1-.7 1.5-.8 1-2.2 1.4-3.5 1.7-1.4.4-2.9-.4-4.4-.4-3.7-1.1-4.1-2.3-5.4-2.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M497.7 331.5c1.3.6 2 1.7 5.4 2.8 1.3 0 2.8.6 4 .6-1.5.3-1.5.5-2.8.8-2.6.6.5.2-2.3.5-2.4.3-3.4 1-5.7.8a11 11 0 0 1-6.3-2.5c-.6-.4-4.1-1.3-6-3h13.7z"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    strokeMiterlimit: 2.6,
    strokeWidth: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#022743",
    d: "M476.6 259.7s1.7 15 7.5 14.4"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#022847",
    d: "M484.2 274c-3 .2-4.9-3.5-6-7a46.3 46.3 0 0 1-1.5-7.3"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#032b4c",
    d: "M484.2 274c-3-.1-4.9-3.8-5.8-7a43.6 43.6 0 0 1-1.7-7.4"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#032d4f",
    d: "M484.2 274c-2.9-.3-4.9-4.1-5.8-7.2a48.2 48.2 0 0 1-1.7-7.2"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#032f53",
    d: "M484.2 273.9c-2.9-.5-4.9-4.4-5.8-7.2a43 43 0 0 1-1.7-7.2"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#043258",
    d: "M484.2 273.8c-3-.6-4.9-4.6-5.7-7.1-1.1-3.2-1.8-7.1-1.9-7.2"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#04345b",
    d: "M484.2 273.8c-2.9-.9-4.9-4.9-5.6-7.2a46 46 0 0 1-2-7.2"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#04365e",
    d: "M484.3 273.7c-3-1-5-5-5.7-7.3a48.7 48.7 0 0 1-1.9-7"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#043862",
    d: "M484.3 273.7c-3-1.2-5-5.4-5.6-7.3a47.5 47.5 0 0 1-2-7.1"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#053b67",
    d: "M484.3 273.6c-3-1.3-5-5.6-5.6-7.3-1-2.8-2-6.8-2-7"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#053d6a",
    d: "M484.3 273.6c-3-1.6-5-6-5.5-7.4a50.3 50.3 0 0 1-2.1-7"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#053f6e",
    d: "M484.3 273.5c-3-1.7-5-6.2-5.4-7.4a45.7 45.7 0 0 1-2.2-7"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#064172",
    d: "M484.4 273.5c-3-2-5-6.4-5.5-7.5a66 66 0 0 1-2.2-7"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#00209f",
    d: "M476.7 259a47 47 0 0 0 2.3 6.9c.3.8 2.4 5.4 5.4 7.5"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#022743",
    d: "M476.9 256.3s4.8 12 8 10.6"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#022a49",
    d: "M484.8 266.9c-1.3.5-3.3-1.8-5-4.6a65.2 65.2 0 0 1-3-6"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#032d4f",
    d: "M484.8 266.8c-1.2.5-3.2-1.8-4.9-4.6a86 86 0 0 1-3-6"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#033054",
    d: "M484.8 266.8c-1 .4-3.2-1.7-4.9-4.7a91.5 91.5 0 0 1-3-5.9"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#043359",
    d: "M484.8 266.8c-.8.3-3.1-1.7-4.8-4.8-2-3.4-3-5.8-3-5.8"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#043760",
    d: "M484.9 266.7c-.7.3-3.1-1.7-4.8-4.8l-3.1-5.8"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#053a65",
    d: "M484.9 266.7c-.6.3-3-1.7-4.8-4.9a749.5 749.5 0 0 0-3.2-5.8"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#053d6a",
    d: "M484.9 266.7c-.4.2-3-1.6-4.7-5a281 281 0 0 0-3.2-5.7"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#064171",
    d: "M484.9 266.7c-.2 0-2.9-1.6-4.7-5L477 256"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#00209f",
    d: "M477 255.9s1 1.4 3.3 5.7a13.6 13.6 0 0 0 4.5 5m8 12.1 3.8-.7m-4-3.1 4.1 2.2"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#064171",
    d: "m492.5 275 4.2 2"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#053e6c",
    d: "m492.5 275.2 4.2 2"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#053b67",
    d: "m492.5 275.4 4.2 1.8"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#043862",
    d: "m492.6 275.6 4.2 1.6"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#04355c",
    d: "m492.6 275.8 4.2 1.4"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#043258",
    d: "m492.6 276 4.3 1.2"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#032f53",
    d: "m492.6 276.1 4.3 1.2"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#032c4d",
    d: "m492.6 276.3 4.4 1"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#022a49",
    d: "m492.6 276.5 4.4.9"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#064171",
    d: "m492.8 278.5 3.9-.5"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#053e6c",
    d: "m492.8 278.3 4-.4"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#053b67",
    d: "m492.8 278.1 4-.3"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#043862",
    d: "m492.8 278 4-.2"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#04355c",
    d: "M492.8 277.7h4"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#043258",
    d: "m492.8 277.5 4.1.2"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#032f53",
    d: "m492.8 277.3 4.2.3"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#032c4d",
    d: "m492.7 277.1 4.3.4"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#022a49",
    d: "m492.7 276.9 4.4.6"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#022743",
    d: "m492.7 276.7 4.4.7m-22.1.4s.2 3.2.9 4.5c1 1.9 3.9 4.7 7.2 6.8"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#022847",
    d: "M483.2 289.1a27.2 27.2 0 0 1-5.5-4.6 13.7 13.7 0 0 1-1.7-2.3c-.7-1.4-1-4.5-1-4.5"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#032b4c",
    d: "M483.3 289.1a27.2 27.2 0 0 1-5.4-4.7 9.3 9.3 0 0 1-1.7-2.3c-.8-1.4-1.2-4.5-1.2-4.5"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#032d4f",
    d: "M483.3 289.1a31.3 31.3 0 0 1-5.3-4.7 12 12 0 0 1-1.7-2.4c-.8-1.5-1.3-4.5-1.3-4.5"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#032f53",
    d: "M483.4 289a31.3 31.3 0 0 1-5.3-4.7 13.6 13.6 0 0 1-1.7-2.4c-.8-1.5-1.4-4.4-1.4-4.4"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#043258",
    d: "M483.5 289c-2.1-1.3-4-3.5-5.3-4.8a10 10 0 0 1-1.6-2.4c-1-1.5-1.6-4.4-1.6-4.4"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#04345b",
    d: "M483.6 289c-2.1-1.4-4-3.6-5.3-4.9a15.1 15.1 0 0 1-1.6-2.3 21.4 21.4 0 0 1-1.7-4.5"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#04365e",
    d: "M483.6 289c-2-1.4-4-3.7-5.1-5a14 14 0 0 1-1.7-2.3c-1-1.7-1.8-4.5-1.8-4.5"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#043862",
    d: "M483.7 289c-2-1.4-4-3.8-5.1-5a15 15 0 0 1-1.6-2.4 26 26 0 0 1-2-4.5"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#053b67",
    d: "M483.8 289c-2-1.5-4-4-5-5.1a13.8 13.8 0 0 1-1.7-2.4c-1.1-1.8-2-4.5-2-4.5"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#053d6a",
    d: "M483.9 289c-2-1.5-4-4-5-5.2a16.8 16.8 0 0 1-1.7-2.4c-1-1.8-2.1-4.5-2.1-4.5"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#053f6e",
    d: "M484 289c-2-1.5-4-4.2-5-5.3a18.7 18.7 0 0 1-1.7-2.4l-2.2-4.4"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#064172",
    d: "M484 289c-2-1.6-3.9-4.3-4.9-5.4a16.1 16.1 0 0 1-1.6-2.4l-2.4-4.4"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#00209f",
    d: "M475 276.7s3 5.3 4.3 6.8c1 1 2.8 4 4.8 5.5"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#011d33",
    d: "m475.2 290 10.2 6.6 2-3-1-2.7"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#011e34",
    d: "m475.2 289.9 10.2 6.5h.1l1.7-3s0-.3-.3-.7l-.6-1.7"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#022037",
    d: "M475.2 289.9c2.9 1.9 4.1 2.7 10.2 6.4l.1-.1 1.6-2.9-.2-.7a18.1 18.1 0 0 1-.6-1.6"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#022139",
    d: "M475.2 289.9c2.8 1.8 4.3 2.8 10.2 6.3l.1-.1 1.5-2.9-.2-.7-.5-1.5"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#02223b",
    d: "M475.2 289.8c2.7 1.8 4.5 2.9 10.2 6.3l.1-.2 1.4-2.8-.1-.7a8.2 8.2 0 0 1-.5-1.4"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#02233d",
    d: "M475.3 289.8c2.5 1.7 4.6 3 10.1 6.1h.1c0-.3 1.3-2.9 1.3-3l-.1-.5a9.6 9.6 0 0 1-.4-1.5"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#022540",
    d: "M475.3 289.8c2.4 1.6 4.7 3 10.2 6v-.1l1.2-2.8v-.6a5 5 0 0 1-.4-1.3"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#022541",
    d: "M475.3 289.8c2.3 1.6 5 3 10.2 5.9v-.2l1.1-2.8v-.5a4.8 4.8 0 0 1-.4-1.3"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#022743",
    d: "M475.3 289.8a110 110 0 0 0 10.2 5.8v-.2l1-2.8v-.5a4.1 4.1 0 0 1-.3-1.2"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#022847",
    d: "M475.3 289.7a92.6 92.6 0 0 0 10.2 5.8v-.2c0-.3 1-2.8 1-2.8v-.5c-.3-.3-.3-.7-.3-1"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#022a49",
    d: "M475.3 289.7a80.5 80.5 0 0 0 10.2 5.6.3.3 0 0 0 0-.1c0-.4.8-2.8.8-2.8s.2-.1 0-.4v-1"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#032a4a",
    d: "M475.3 289.7a80 80 0 0 0 10.2 5.5v-.2l.7-2.7s.2-.1 0-.4v-1"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#032b4c",
    d: "M475.4 289.7a67.8 67.8 0 0 0 10 5.4l.2-.2.5-2.7s.2-.1.1-.4c-.1-.3 0-.5 0-.8"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#032d4f",
    d: "M475.4 289.7a62.4 62.4 0 0 0 10 5.3l.2-.2.4-2.8s.3 0 .2-.3c-.2-.3 0-.4 0-.7"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#032e50",
    d: "M475.4 289.7c1.7 1 6 3.6 10.1 5.2v-.2l.4-2.7s.3 0 .2-.3c-.1-.3 0-.3.1-.7"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#032f53",
    d: "M475.4 289.6a54.3 54.3 0 0 0 10.1 5.1.5.5 0 0 0 0-.2l.3-2.7.2-.2c-.1-.3 0-.3.2-.6"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#033156",
    d: "M475.4 289.6c1.5 1 6.3 3.8 10.1 5a.5.5 0 0 0 0-.2l.2-2.7s.4 0 .3-.2c-.2-.3 0-.2.1-.6"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#043258",
    d: "M475.4 289.6a45 45 0 0 0 10.1 4.9l.1-.2v-2.7s.4 0 .3-.2c-.1-.2.1-.1.3-.4"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#043359",
    d: "M475.4 289.6c1.3.9 6.7 4 10.1 4.7l.1-.2-.1-2.6s.4 0 .3-.1c0-.3.2-.1.3-.4"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#04355c",
    d: "M475.4 289.6c1.2.8 6.8 4 10.1 4.6l.1-.2-.3-2.6.5-.1c-.1-.3.2 0 .3-.4"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#04365e",
    d: "M475.4 289.6c1.1.7 7 4 10.1 4.5l.1-.2c0-.7-.3-2.6-.4-2.6h.5c0-.3.2 0 .4-.3"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#043760",
    d: "M475.4 289.6c1 .6 7.2 4.1 10.1 4.4l.1-.3c0-.6-.4-2.5-.5-2.6 0 0 .6.2.5 0 0-.1.3.2.5-.1"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#043862",
    d: "M475.4 289.6c1 .5 7.3 4.2 10.1 4.3l.2-.3a12.5 12.5 0 0 0-.7-2.6s.6.2.5 0c0-.1.4.3.6 0"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#053a65",
    d: "M475.5 289.5c.8.5 7.4 4.3 10 4.2l.2-.2c0-.8-.7-2.6-.8-2.6s.6.2.6 0c0 0 .3.4.6 0"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#053b67",
    d: "M475.5 289.5c.7.5 7.6 4.4 10 4.1l.2-.3c0-.7-.8-2.4-.9-2.5l.6.1c0-.1.5.3.7 0"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#053c68",
    d: "M475.5 289.5c.6.4 7.8 4.4 10 4l.2-.3a6 6 0 0 0-1-2.5l.7.1c0-.1.4.4.7.1"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#053e6c",
    d: "M475.5 289.5c.5.3 8 4.5 10 3.9a.5.5 0 0 0 .2-.3c0-.8-1-2.5-1.1-2.5l.7.1s.5.6.8.3"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#053f6e",
    d: "M475.5 289.5c.4.2 8 4.6 10 3.8l.2-.4c0-.8-1.1-2.4-1.2-2.5l.7.3s.6.6.9.2"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#053f6f",
    d: "M475.5 289.5c.3.2 8.2 4.6 10 3.6l.2-.3c0-.9-1.2-2.4-1.3-2.5l.7.3s.6.6 1 .4"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#064171",
    d: "M475.5 289.4c.2.2 8.4 4.8 10 3.6a.7.7 0 0 0 .2-.3c0-1-1.3-2.4-1.4-2.5l.8.3s.6.7 1 .4"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#064374",
    d: "M475.5 289.4c.1 0 8.6 4.9 10 3.5l.2-.3c0-1-1.4-2.4-1.6-2.5l1 .3s.6.8 1 .6"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#00209f",
    d: "M475.6 289.4s9.7 5.5 10.1 3c0-1-1.6-2.4-1.6-2.4l.9.3s.6 1 1 .6"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#011d33",
    d: "m474.4 315.1-7.5 12.6a5.2 5.2 0 0 1-1.8-2.2c-.6-1.7-.5-1.7-1-3.6l-.4-3.4c-.3-1.2-1.9-4.8-2-6.2"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#011d33",
    d: "M461.8 312.3c0 1.4 1.6 5 1.9 6 .2 1.2.2 2.4.5 3.5.4 1.9.3 1.8 1 3.6a5.2 5.2 0 0 0 1.7 2.2l7.5-12.5"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#011e34",
    d: "M461.8 312.3c0 1.4 1.6 5 1.8 6 .3 1.2.3 2.3.6 3.4.4 1.8.3 1.8 1 3.6.2.8 1.2 1.8 1.7 2.1l7.5-12.3"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#011e34",
    d: "M461.8 312.3c0 1.4 1.6 4.9 1.8 6 .3 1 .3 2.2.6 3.3.4 1.8.3 1.8 1 3.5a5.5 5.5 0 0 0 1.7 2.2l7.5-12.2"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#011f36",
    d: "M461.8 312.3c0 1.3 1.6 4.8 1.8 5.9.3 1.1.3 2.3.6 3.3.4 1.8.3 1.8 1 3.5a5.5 5.5 0 0 0 1.7 2.1l7.5-12"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#011f36",
    d: "M461.8 312.3c0 1.3 1.6 4.8 1.8 5.9.3 1 .3 2.2.6 3.3.4 1.7.3 1.7 1 3.4.2.8 1.2 1.8 1.7 2.1l7.5-11.9"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#022037",
    d: "M461.8 312.3c0 1.3 1.5 4.7 1.8 5.8.3 1 .3 2.2.6 3.3.4 1.7.3 1.7 1 3.4.2.8 1.2 1.7 1.7 2 .2.1 7.4-11.6 7.5-11.7"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#022037",
    d: "M461.8 312.3c0 1.3 1.5 4.6 1.8 5.7l.6 3.3c.4 1.7.4 1.7 1 3.3.2.8 1.2 1.8 1.7 2.1.2 0 7.3-11.5 7.5-11.6"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#022139",
    d: "M461.8 312.3c0 1.3 1.5 4.6 1.8 5.7.3 1 .3 2.2.6 3.2.4 1.7.4 1.7 1 3.3.3.8 1.2 1.7 1.7 2 .2.1 7.3-11.3 7.5-11.4"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#022139",
    d: "M461.8 312.3c0 1.3 1.5 4.6 1.8 5.6.3 1 .3 2.2.6 3.2.4 1.7.4 1.7 1 3.3a5.4 5.4 0 0 0 1.7 2c.3 0 7.3-11.2 7.5-11.3"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#022139",
    d: "M461.8 312.3c0 1.3 1.5 4.5 1.8 5.6.3 1 .3 2 .6 3.1.5 1.7.4 1.7 1 3.3.3.8 1.2 1.7 1.7 2 .3 0 7.2-11 7.5-11.2"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#02223b",
    d: "M461.8 312.3c0 1.3 1.5 4.4 1.8 5.5.3 1 .3 2.1.6 3 .5 1.8.4 1.8 1 3.3a5 5 0 0 0 1.7 2c.3.1 7.2-10.9 7.5-11"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#02223b",
    d: "M461.8 312.3c0 1.2 1.5 4.4 1.8 5.4.3 1 .3 2.2.6 3.1.5 1.7.4 1.7 1 3.2a5.2 5.2 0 0 0 1.7 2c.3.1 7.2-10.8 7.5-10.9"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#02233d",
    d: "M461.8 312.3c0 1.2 1.5 4.3 1.8 5.4l.6 3c.5 1.7.4 1.7 1 3.2a5.1 5.1 0 0 0 1.8 2c.3 0 7-10.6 7.4-10.8"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#02233d",
    d: "M461.8 312.3c0 1.2 1.4 4.3 1.8 5.3l.6 3 1 3.2a7 7 0 0 0 1.8 2c.3 0 7-10.6 7.4-10.7"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#02233e",
    d: "M461.8 312.3c0 1.2 1.4 4.3 1.8 5.3l.6 3 1 3a6 6 0 0 0 1.8 2c.3.1 7-10.3 7.4-10.5"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#02233e",
    d: "M461.8 312.3c0 1.1 1.4 4.2 1.8 5.2l.6 3 1 3a5 5 0 0 0 1.8 2c.4 0 7-10.3 7.4-10.4"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#022540",
    d: "M461.8 312.2c0 1.2 1.4 4.2 1.8 5.3l.6 2.9 1 3a5.2 5.2 0 0 0 1.8 2c.4 0 7-10.1 7.4-10.3"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#022540",
    d: "M461.8 312.2c0 1.2 1.4 4.2 1.8 5.2l.6 2.9 1 3c.4.7 1.3 1.5 1.8 1.8.4.2 7-9.8 7.4-10"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#022540",
    d: "M461.8 312.2c0 1.2 1.4 4.1 1.8 5.1l.7 2.9c.4 1.5.4 1.6 1 3a5 5 0 0 0 1.7 1.8c.4.1 7-9.7 7.4-9.9"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#022541",
    d: "M461.8 312.2c0 1.2 1.4 4 1.8 5l.7 3 1 2.9a5.2 5.2 0 0 0 1.7 1.8c.4.1 6.9-9.6 7.4-9.8"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#022541",
    d: "M461.8 312.2c0 1.1 1.4 4 1.8 5l.7 2.8 1 3c.3.6 1.2 1.5 1.7 1.8.5 0 6.9-9.5 7.4-9.7"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#022743",
    d: "M461.8 312.2c0 1.1 1.4 4 1.8 5l.7 2.7c.4 1.5.5 1.5 1 2.9a6 6 0 0 0 1.7 1.8c.5.1 6.8-9.3 7.4-9.5"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#022743",
    d: "M461.8 312.2c0 1.1 1.4 4 1.8 5l.7 2.6 1 3a5 5 0 0 0 1.7 1.6c.5.2 6.8-9 7.4-9.3"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#022845",
    d: "M461.8 312.2c0 1.1 1.4 3.9 1.8 4.8l.7 2.8 1 2.8a4.9 4.9 0 0 0 1.7 1.7c.6.2 6.8-9 7.4-9.2"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#022845",
    d: "M461.8 312.2c0 1.1 1.4 3.8 1.8 4.8l.7 2.7c.4 1.4.5 1.4 1 2.7a5.3 5.3 0 0 0 1.7 1.8c.6.2 6.7-8.9 7.4-9"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#022847",
    d: "M461.8 312.2c0 1 1.3 3.7 1.8 4.7l.7 2.7 1 2.7a4.8 4.8 0 0 0 1.7 1.7c.6.2 6.7-8.7 7.4-8.9"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#022847",
    d: "M461.8 312.2c0 1 1.3 3.7 1.8 4.6l.7 2.7 1.1 2.7a5 5 0 0 0 1.6 1.7c.7.2 6.7-8.6 7.4-8.8"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#022847",
    d: "M461.8 312.2c0 1 1.3 3.7 1.8 4.6l.7 2.6 1.1 2.7a5 5 0 0 0 1.6 1.7c.7.1 6.7-8.4 7.4-8.7"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#022a49",
    d: "M461.8 312.2c0 1 1.3 3.6 1.8 4.6l.7 2.5 1.1 2.7c.4.6 1.1 1.3 1.7 1.6.6.2 6.6-8.2 7.3-8.5"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#022a49",
    d: "M461.8 312.2c0 1 1.3 3.5 1.8 4.5l.7 2.5 1.1 2.6c.4.6 1.1 1.4 1.7 1.6.7.3 6.5-8 7.3-8.3"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#032a4a",
    d: "M461.8 312.2c0 1 1.3 3.5 1.8 4.4l.7 2.5c.5 1.3.5 1.4 1.2 2.6.3.6 1 1.4 1.6 1.6.7.2 6.5-8 7.3-8.2"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#032a4a",
    d: "M461.8 312.2c0 1 1.3 3.4 1.7 4.4l.8 2.4 1.2 2.6a5 5 0 0 0 1.6 1.6c.7.2 6.5-7.8 7.3-8.1"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#032b4c",
    d: "M461.8 312.2c0 1 1.2 3.4 1.7 4.3.4.8.5 1.7.8 2.4l1.2 2.6c.3.6 1 1.2 1.6 1.5.7.3 6.4-7.6 7.3-8"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#032b4c",
    d: "M461.8 312.2c0 1 1.2 3.3 1.7 4.3.4.7.5 1.6.8 2.3l1.2 2.6c.3.5 1 1.2 1.6 1.5.8.2 6.4-7.5 7.3-7.8"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#032c4d",
    d: "M461.8 312.2c0 1 1.2 3.3 1.7 4.2.4.8.5 1.6.8 2.4l1.2 2.4c.3.6 1 1.3 1.6 1.6.8.2 6.4-7.4 7.3-7.7"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#032c4d",
    d: "M461.8 312.2c0 .9 1.2 3.2 1.7 4.1l.9 2.4c.4 1.2.5 1.3 1.1 2.4a5.2 5.2 0 0 0 1.6 1.5c.8.3 6.3-7.2 7.3-7.5"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#032c4d",
    d: "M461.8 312.2a13 13 0 0 0 1.7 4l.9 2.4c.4 1.2.5 1.2 1.1 2.4a4.7 4.7 0 0 0 1.6 1.4c.9.4 6.3-7 7.3-7.3"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#032d4f",
    d: "M461.8 312.2c0 .9 1.2 3.1 1.7 4 .4.8.5 1.6.9 2.3.4 1.2.5 1.3 1.1 2.3.3.6 1 1.3 1.6 1.5.9.3 6.3-6.8 7.3-7.2"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#032d4f",
    d: "M461.8 312.2c0 .8 1.2 3 1.7 4 .4.7.5 1.5.9 2.2.4 1.2.6 1.2 1.1 2.4a5 5 0 0 0 1.6 1.4c1 .3 6.3-6.7 7.3-7.1"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#032e50",
    d: "M461.8 312.2c0 .8 1.2 3 1.7 4 .4.6.5 1.4.9 2.1.4 1.2.6 1.2 1.1 2.3a5.4 5.4 0 0 0 1.6 1.5c1 .2 6.3-6.6 7.3-7"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#032e50",
    d: "M461.8 312.2c0 .8 1.1 3 1.7 3.8.4.8.5 1.5.9 2.2.4 1.2.6 1.3 1.1 2.3a4.8 4.8 0 0 0 1.6 1.4c1 .3 6.2-6.4 7.3-6.8"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#032f53",
    d: "M461.8 312.2c0 .8 1.1 3 1.7 3.8.4.7.5 1.5.9 2.1.4 1.1.6 1.2 1.2 2.3a5 5 0 0 0 1.5 1.4c1 .3 6.2-6.3 7.3-6.7"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#032f53",
    d: "M461.8 312.2a11 11 0 0 0 1.7 3.7c.4.7.5 1.5.9 2.2l1.2 2.1a5 5 0 0 0 1.5 1.4c1 .3 6.2-6 7.3-6.5"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#033054",
    d: "M461.8 312.2a12 12 0 0 0 1.7 3.7c.4.6.5 1.4.9 2l1.2 2.2a5.1 5.1 0 0 0 1.6 1.4c1 .3 6-6 7.2-6.4"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#033054",
    d: "M461.8 312.2c0 .7 1 2.7 1.7 3.6.4.7.5 1.4 1 2l1 2.2a4.5 4.5 0 0 0 1.7 1.3c1 .4 6-5.8 7.2-6.2"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#033054",
    d: "M461.8 312.2c0 .7 1 2.7 1.7 3.6l1 2c.4 1 .6 1.1 1.1 2a5.4 5.4 0 0 0 1.6 1.4c1 .3 6-5.7 7.2-6.1"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#033156",
    d: "M461.8 312.2c0 .7 1 2.7 1.7 3.5l1 2c.3 1 .6 1.1 1.1 2a5.4 5.4 0 0 0 1.5 1.4c1.1.3 6-5.6 7.3-6"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#033156",
    d: "M461.8 312.2c0 .7 1 2.6 1.7 3.4l1 2c.3 1 .6 1.1 1.1 2a5.4 5.4 0 0 0 1.5 1.3c1.2.3 6-5.3 7.3-5.8"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#043258",
    d: "M461.8 312.2c0 .7 1 2.6 1.7 3.4l1 1.9c.3 1 .6 1 1.2 2 .3.5 1 1 1.4 1.3 1.2.3 6-5.2 7.3-5.7"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#043258",
    d: "M461.8 312.2a8 8 0 0 0 1.7 3.3l1 2c.3.9.6 1 1.2 2 .3.4 1 1 1.4 1.1 1.2.4 6-5 7.3-5.5"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#043359",
    d: "M461.8 312.2c0 .6 1 2.4 1.7 3.3l1 1.8c.4 1 .6 1.1 1.2 2 .3.5 1 1 1.4 1.2 1.3.3 6-5 7.3-5.4"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#043359",
    d: "M461.8 312.2c0 .6 1 2.4 1.7 3.2l1 1.9c.4.8.6 1 1.2 1.8.4.5 1 1 1.5 1.2 1.2.4 5.8-4.7 7.2-5.2"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#04345b",
    d: "M461.8 312.2c0 .6 1 2.4 1.7 3.1l1 1.9c.4.9.7 1 1.2 1.8.4.5 1 1 1.5 1.2 1.2.4 5.8-4.6 7.2-5.1"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#04345b",
    d: "M461.8 312.2c0 .6 1 2.3 1.7 3l1 1.9c.4.8.7 1 1.2 1.8.4.5 1 1 1.5 1.2 1.3.4 5.8-4.5 7.2-5"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#04345b",
    d: "M461.8 312.2c0 .6 1 2.2 1.7 3l1 1.8c.4.9.7 1 1.2 1.8.4.4 1 1 1.5 1.1 1.3.4 5.8-4.3 7.2-4.8"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#04355c",
    d: "M461.8 312.2c0 .5 1 2.2 1.7 3l1 1.7c.4.8.7 1 1.2 1.8.4.4 1 .9 1.5 1 1.3.5 5.7-4.1 7.2-4.6"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#04355c",
    d: "M461.8 312.2c0 .5 1 2.1 1.7 3l1 1.6c.4.8.7 1 1.3 1.7.3.5 1 1 1.4 1.1 1.3.5 5.7-4 7.2-4.5"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#04365e",
    d: "M461.8 312.2c0 .5 1 2.1 1.7 2.9l1 1.6c.4.9.7 1 1.3 1.7.3.5 1 .9 1.4 1.1 1.4.4 5.7-3.9 7.2-4.4"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#04365e",
    d: "M461.8 312.2c0 .5 1 2 1.7 2.8l1 1.6c.4.8.7 1 1.3 1.7.3.4 1 .9 1.4 1 1.4.5 5.6-3.7 7.2-4.2"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#043760",
    d: "M461.8 312.2c0 .5 1 2 1.7 2.8l1 1.5c.4.8.7 1 1.3 1.7.3.4 1 .8 1.4 1 1.4.4 5.6-3.6 7.2-4.1"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#043760",
    d: "M461.8 312.2c0 .5 1 2 1.7 2.7l1 1.6c.4.7.7.8 1.3 1.6.3.4 1 .8 1.4 1 1.5.4 5.6-3.5 7.2-4"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#043862",
    d: "M461.8 312.2c0 .5 1 1.9 1.7 2.6l1 1.6c.4.7.7.9 1.3 1.5.3.4 1 .8 1.4 1 1.5.5 5.5-3.3 7.2-3.9"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#043862",
    d: "M461.8 312.2c0 .4 1 1.8 1.7 2.6l1 1.5c.4.7.7.9 1.3 1.5l1.4 1c1.5.4 5.5-3.2 7.2-3.8"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#043862",
    d: "M461.8 312.2c0 .4.9 1.8 1.7 2.5l1 1.5c.4.7.8.8 1.3 1.5l1.4 1c1.5.4 5.5-3 7.2-3.7"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#043963",
    d: "M461.8 312.2c0 .4.9 1.7 1.7 2.4l1 1.5c.4.7.8.8 1.3 1.5l1.4.9c1.5.5 5.5-2.8 7.2-3.5"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#043963",
    d: "M461.8 312.2c0 .4.9 1.7 1.7 2.4l1 1.4c.4.7.8.8 1.3 1.5l1.4.9c1.6.5 5.5-2.7 7.2-3.4"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#053a65",
    d: "M461.8 312.2c0 .4.9 1.6 1.7 2.3l1 1.4 1.3 1.4 1.4 1c1.6.4 5.4-2.6 7.2-3.3"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#053a65",
    d: "M461.8 312.2c0 .3.8 1.6 1.7 2.3l1 1.3c.5.7.8.8 1.4 1.4.3.4.9.7 1.4.9 1.6.5 5.3-2.4 7.1-3"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#053b67",
    d: "M461.8 312.2c0 .3.8 1.5 1.7 2.2l1 1.3 1.4 1.4c.4.3.9.7 1.4.8 1.6.5 5.3-2.2 7.1-2.9"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#053b67",
    d: "M461.8 312.2c0 .3.8 1.5 1.7 2.1.3.5.6 1 1 1.3.5.7.8.8 1.4 1.4l1.4.8c1.6.5 5.2-2 7.1-2.8"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#053c68",
    d: "M461.8 312.2c0 .3.8 1.4 1.7 2.1l1 1.3 1.4 1.3c.4.3.9.6 1.4.7 1.7.6 5.2-1.9 7.1-2.6"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#053c68",
    d: "M461.8 312.2c0 .3.8 1.4 1.7 2l1 1.3 1.4 1.2 1.4.8c1.7.5 5.2-1.8 7.1-2.5"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#053c68",
    d: "M461.8 312.2a6 6 0 0 0 1.7 2l1 1.2 1.4 1.2a6 6 0 0 0 1.4.8c1.7.5 5.1-1.7 7.1-2.4"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#053d6a",
    d: "M461.8 312.2c0 .2.8 1.2 1.7 2l1 1 1.4 1.3a6 6 0 0 0 1.4.8c1.8.5 5.1-1.5 7.1-2.3"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#053d6a",
    d: "M461.8 312.2a6 6 0 0 0 1.7 1.9l1 1.1 1.4 1.1 1.4.8c1.8.5 5.1-1.3 7.1-2"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#053e6c",
    d: "M461.8 312.2c0 .2.7 1.1 1.7 1.8l1 1.1c.5.5 1 .7 1.5 1.1l1.3.8c1.8.5 5.1-1.2 7.1-2"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#053e6c",
    d: "M461.8 312.2c0 .2.7 1.1 1.6 1.8l1.1 1c.5.5 1 .7 1.5 1.1l1.3.7c1.8.6 5-1 7.1-1.8"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#053f6e",
    d: "M461.8 312.2c0 .1.7 1 1.6 1.7l1.1 1c.5.5 1 .7 1.5 1 .4.4.8.6 1.3.8 1.8.6 5-1 7.1-1.7"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#053f6e",
    d: "M461.8 312.2c0 .1.7 1 1.6 1.6a14.2 14.2 0 0 0 1.2 1c.4.5.9.7 1.4 1 .4.3.9.6 1.3.7 1.9.6 5-.7 7.1-1.5"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#053f6f",
    d: "M461.8 312.2c0 .1.7 1 1.6 1.6l1.2 1 1.4 1 1.3.6c2 .5 5-.6 7.1-1.4"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#053f6f",
    d: "M461.8 312.2c0 .1.7.9 1.6 1.5l1.2 1 1.4 1 1.3.6c2 .5 5-.5 7.1-1.3"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#053f6f",
    d: "M461.8 312.2c0 .1.7.8 1.6 1.5l1.2.9 1.4 1 1.3.5c2 .6 5-.3 7.1-1"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#064171",
    d: "M461.8 312.2s.7.8 1.6 1.4l1.2.9 1.5.9 1.2.6c2 .6 4.9-.2 7.1-1"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#064171",
    d: "m461.8 312.2 1.6 1.4 1.2.8 1.5.9 1.3.5c2 .6 4.8 0 7-.8"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#064172",
    d: "M461.8 312.2s.7.7 1.6 1.3l1.2.8 1.5.8 1.3.6c2 .6 4.7.2 7-.7"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#064172",
    d: "M461.8 312.1c0 .1.7.7 1.6 1.3l1.2.8 1.5.8 1.3.6c2 .6 4.7.3 7-.6"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#064374",
    d: "M461.8 312.1c0 .1.6.7 1.6 1.3l1.2.7a12.7 12.7 0 0 0 2.8 1.3c2 .6 4.7.5 7-.4"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#064374",
    d: "M461.8 312.1s.6.6 1.6 1.2l1.2.7a15.7 15.7 0 0 0 2.8 1.3c2 .6 4.7.6 7-.3"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#00209f",
    d: "m461.8 312.1 1.6 1.2 1.2.7 1.5.6a12 12 0 0 0 8.3.4m-12.6-2.9s6.5 5.1 12.6 3"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#022743",
    d: "M461.6 292.2s1.2 8 1.7 9.3c.4 1 3 5.6 6.9 6.7"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#022a49",
    d: "M461.6 292.2s1.3 8 1.8 9.2c.5 1 2.8 5.4 6.8 6.8"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#032b4c",
    d: "M461.6 292.1s1.4 8 1.9 9.2a14 14 0 0 0 6.7 6.9"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#032e50",
    d: "M461.6 292.1s1.5 8 2 9.1c.5 1 2.5 5 6.6 7"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#033054",
    d: "M461.6 292.1s1.6 7.9 2 9a15.2 15.2 0 0 0 6.7 7"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#043359",
    d: "M461.6 292.1s1.6 7.8 2.2 9a15.8 15.8 0 0 0 6.5 7"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#04355c",
    d: "M461.6 292s1.7 7.8 2.3 9c.5 1.1 2 4.3 6.4 7"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#043760",
    d: "M461.7 292s1.7 7.8 2.3 9c.5 1 1.9 4 6.3 7"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#053a65",
    d: "M461.7 292s1.8 7.7 2.4 8.9c.5 1 1.7 3.8 6.2 7.1"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#053c68",
    d: "M461.7 292s1.9 7.7 2.5 8.8c.6 1.1 1.6 3.5 6.1 7.2"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#053f6e",
    d: "M461.7 292s2 7.6 2.6 8.8c.5 1 1.4 3.2 6 7.2"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#064172",
    d: "M461.8 292s2 7.5 2.6 8.7c.6 1.1 1.3 3 6 7.2"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#00209f",
    d: "M461.8 292s2.1 7.5 2.7 8.6c.6 1.1 1.1 2.8 5.9 7.3"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#022743",
    d: "M462 287.2s1.1 11.4 9.3 14.6"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#022a49",
    d: "M462 287.2c.1 0 .5 3.7 2.2 7.2 1.3 2.8 3.5 5.9 7 7.4"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#032b4c",
    d: "M462.1 287.2s.5 3.8 2.2 7.2a15 15 0 0 0 7 7.4"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#032e50",
    d: "M462.1 287.2s.7 3.9 2.3 7.1c1.1 2.3 3.3 5.7 6.9 7.4"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#033054",
    d: "M462.2 287.2s.7 4 2.3 7c1 2.2 3.2 5.7 6.8 7.5"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#043359",
    d: "M462.2 287.2c0 .1.8 4 2.4 7 1 2 3.1 5.6 6.7 7.5"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#04355c",
    d: "M462.2 287.2c0 .1 1 4.2 2.5 7a18 18 0 0 0 6.6 7.4"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#043760",
    d: "M462.2 287.1c0 .3 1 4.4 2.6 7 .8 1.5 3 5.4 6.5 7.5"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#053a65",
    d: "M462.2 287.1a30 30 0 0 0 2.6 6.9c.8 1.4 3 5.4 6.5 7.5"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#053c68",
    d: "M462.3 287.1c0 .3 1.2 4.5 2.6 6.8.7 1.3 2.8 5.4 6.4 7.7"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#053f6e",
    d: "M462.3 287.1a30 30 0 0 0 2.8 6.8c.6 1 2.6 5.2 6.2 7.6"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#064172",
    d: "M462.3 287.1a31 31 0 0 0 2.9 6.7c.5.8 2.5 5.2 6 7.7"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#00209f",
    d: "M462.3 287.1c0 .3 1.6 4.9 3 6.6.4.7 2.4 5.2 6 7.8"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#022743",
    d: "M462.2 284s2.4 9.2 9 11.5"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#022847",
    d: "M462.2 284s.9 3.3 3 6.4c1.5 2.2 3.6 4.2 6 5"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#032a4a",
    d: "M462.2 284s1 3.2 3 6.4c1.6 2.1 3.7 4.3 6 5"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#032c4d",
    d: "M462.2 284s1 3.1 3.2 6.3c1.5 2.2 3.7 4.4 5.8 5.1"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#032f53",
    d: "M462.2 283.9s1 3.1 3.3 6.3a15 15 0 0 0 5.7 5.2"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#033156",
    d: "M462.2 283.9s1 3 3.3 6.2c1.7 2.3 4 4.7 5.7 5.3"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#043359",
    d: "M462.2 283.8s1 3 3.4 6.2a17 17 0 0 0 5.6 5.4"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#04355c",
    d: "M462.2 283.8a27.1 27.1 0 0 0 9 11.6"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#043760",
    d: "M462.3 283.8s1 2.9 3.5 6.1a21 21 0 0 0 5.4 5.4"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#043963",
    d: "M462.3 283.8s1 2.8 3.5 6a23 23 0 0 0 5.4 5.5"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#053b67",
    d: "M462.3 283.7s1.1 2.8 3.6 6a28 28 0 0 0 5.3 5.6"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#053e6c",
    d: "M462.3 283.7s1.2 2.7 3.7 6a39 39 0 0 0 5.2 5.6"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#053f6f",
    d: "M462.3 283.7s1.2 2.7 3.8 5.9a44 44 0 0 0 5.1 5.7"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#064172",
    d: "M462.3 283.6s1.3 2.7 3.9 6c2 2.5 4.9 5.6 5 5.7"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#00209f",
    d: "M462.3 283.6s1.3 2.6 3.9 5.8c2.1 2.7 5 5.9 5 5.9m8.7 1.3 4.6.8m-4.1 2.6 4-1.7"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#064171",
    d: "m479.9 296.7 4.5.7"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#053e6c",
    d: "m479.9 296.9 4.6.5"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#053b67",
    d: "m479.9 297 4.6.4"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#043862",
    d: "m479.9 297.2 4.7.3"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#04355c",
    d: "M479.9 297.4h4.7"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#043258",
    d: "M480 297.6h4.6"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#032f53",
    d: "m480 297.7 4.7-.2"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#032c4d",
    d: "m480 297.9 4.7-.3"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#022a49",
    d: "m480 298 4.8-.5"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#064171",
    d: "m480.3 299.8 4.2-1.6"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#053e6c",
    d: "m480.3 299.6 4.3-1.5"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#053b67",
    d: "m480.3 299.5 4.3-1.4"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#043862",
    d: "m480.3 299.3 4.3-1.3"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#04355c",
    d: "m480.2 299.1 4.5-1.2"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#043258",
    d: "m480.2 299 4.5-1.2"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#032f53",
    d: "m480.2 298.7 4.6-.9"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#032c4d",
    d: "m480.1 298.6 4.7-.9"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#022a49",
    d: "m480.1 298.4 4.7-.7"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#022743",
    d: "m480 298.2 4.9-.6"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#032b4c",
    d: "m484.2 331.6-2.6.2-9.9-.2"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#032e50",
    d: "m484.3 331.6-2.7.3-9.8-.2"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#033054",
    d: "m484.3 331.6-2.8.4c-.5.1-9.6-.3-9.6-.3"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#043359",
    d: "m484.3 331.7-2.8.5c-.7.1-9.6-.5-9.6-.5"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#04355c",
    d: "m484.3 331.7-3 .6c-.7.2-9.3-.5-9.3-.5"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#043760",
    d: "m484.3 331.7-3 .7c-.8.3-9.2-.6-9.2-.6"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#053a65",
    d: "m484.4 331.8-3.1.8c-1 .2-9.1-.7-9.1-.7"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#053c68",
    d: "m484.4 331.8-3.1 1c-1.2.2-9-.8-9-.8"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#053f6e",
    d: "m484.4 331.9-3.2 1c-1.2.3-8.9-.9-8.9-.9"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#064172",
    d: "M484.4 332s-1.8.7-3.2 1c-1.4.3-8.8-1-8.8-1"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#00209f",
    d: "M472.5 332s7.1 1.4 8.6 1.1c1.5-.3 3.3-1.1 3.3-1.1"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#022a49",
    d: "m486 337 4.8.7 2.7-.2 2.2-.5"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#032d4f",
    d: "M485.8 337s4.7.7 5 .6l2.7-.1 2-.5"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#033054",
    d: "M485.5 336.9s4.9.8 5.3.7l2.6-.2 2-.4"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#043359",
    d: "M485.3 336.7s4.9.9 5.6.8a56.9 56.9 0 0 1 2.5-.2l1.7-.3"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#043760",
    d: "M485 336.6s5 1 5.9.8l2.5-.2 1.5-.3"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#053a65",
    d: "M484.8 336.5s5.1 1 6.1.8l2.4-.2 1.4-.2"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#053d6a",
    d: "M484.5 336.4s5.3 1 6.4.9c.7-.2 2-.3 2.4-.3a24.4 24.4 0 0 0 1.2-.2"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#064171",
    d: "M484.2 336.3s5.4 1.1 6.8.9c.7-.2 1.7-.3 2.2-.3h1.1"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#022743",
    d: "m486.3 337.2 4.4.6 2.9-.1 2.4-.6"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#00209f",
    d: "M484 336.2s5.5 1.2 7 .9c1.5-.3 3-.3 3-.3m11.8 0 4.3-1.6c2.6-1 3-3.6 3-3.6"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#00209f",
    d: "m505.5 336 3.1-1.3c3.8-1.4 3.4-3.2 3.4-3.2"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#053e6c",
    d: "m505.2 336.1 3.4-1.3 1.8-.8c.5-.3 1.2-1 1.3-1.2.4-.5.4-1.3.4-1.3"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#043862",
    d: "m505 336.3 3.6-1.4 1.8-.7 1.4-1.2c.3-.5.4-1.5.4-1.5"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#043258",
    d: "m504.7 336.5 4-1.5 1.6-.7a6 6 0 0 0 1.5-1.2c.2-.3.5-1.6.5-1.6"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#032c4d",
    d: "m504.4 336.7 4.2-1.5 1.7-.7 1.6-1.3.6-1.6"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#053e6c",
    d: "m505.5 336.9 4.6-1.8c.8-.3 1.7-1 2-1.5.6-.9.9-2 .9-2"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#043862",
    d: "m505.1 336.9 5-2c.6-.1 1.7-1 2-1.4.4-.6.7-2 .7-2"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#043258",
    d: "m504.8 336.9 5.4-2a8.1 8.1 0 0 0 1.9-1.4c.3-.5.6-2 .6-2"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#032c4d",
    d: "m504.5 336.9 5.7-2.1 1.8-1.4.7-1.8"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#022743",
    d: "m504.2 336.9 6-2.3 1.7-1.2.6-1.8"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#032b4c",
    d: "m511.3 331.6-2.8.2-10.3-.2"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#032e50",
    d: "m511.3 331.6-2.8.3-10.2-.2"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#033054",
    d: "m511.3 331.6-2.9.4c-.5.1-10-.3-10-.3"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#043359",
    d: "m511.3 331.7-3 .5c-.6.1-9.8-.5-9.8-.5"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#04355c",
    d: "m511.4 331.7-3 .6c-.9.2-9.8-.5-9.8-.5"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#043760",
    d: "m511.4 331.7-3.1.7c-1 .3-9.7-.6-9.7-.6"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#053a65",
    d: "m511.4 331.8-3.2.8c-1 .2-9.5-.7-9.5-.7"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#053c68",
    d: "m511.4 331.8-3.3 1c-1.1.2-9.3-.8-9.3-.8"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#053f6e",
    d: "m511.4 331.9-3.3 1c-1.3.2-9.2-.9-9.2-.9"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#064172",
    d: "M511.4 332s-1.9.7-3.3 1c-1.5.3-9.2-1-9.2-1"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#00209f",
    d: "M499 332s7.5 1.4 9 1.1c1.6-.3 3.5-1.1 3.5-1.1"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 2.6,
    strokeWidth: 0.2,
    d: "M475 290a34 34 0 0 1-.2-3.3c0-5.2-.7-9-.1-14.5.4-4.2 1.5-9.8 1.3-14.4-.1-1.3.1-2.6.2-3.9l21 23.5M467 327.7a5.2 5.2 0 0 1-1.9-2.2c-.6-1.7-.4-1.7-.9-3.6-.2-1.1-.2-2.3-.5-3.4-.2-1.2-1.8-4.8-1.9-6.2-.1-4.8-1.7-8-1.3-13.1.3-4 1.2-9.5.7-13.6l.1-3.6 23.6 15.6m28.5 33.9c.2.5-.3 1.5-.5 1.9l-.5.6c-.2.6-.2.4-.7.9l-.8.6c-.4.3-.7.6-1.1.7-1.8.3-2.5.7-4.2 1.1-1.6.5-.8.4-2 .7l-2.4.7-2.4.6c-2.9.7-5.7.5-8.6.3-1.1 0-4-.7-5-1.4-1.8-1.2-5.7-1.7-7.4-2.9-.3-.2-1.4-.7-1.6-1-1.7-1.3-3-1.7-4.8-2.8"
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "#000",
    strokeMiterlimit: 2.6,
    strokeWidth: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fc0",
    fillRule: "evenodd",
    d: "m484.9 297.6.6-.8-24-15.6-.4.6zm-23.7-16.7c-.2-1 0-2.1.7-2.3 0 0 .5-.1.8 0 .4 0 .5 0 .7.4.3.8-.7 1.3-1.4 1.6-.2 0-.6.1-.7.3l-.1.4.3-.3 1.7-.7c.6-.3.7-1.4.3-1.7-.4-.4-1.8-.3-2 0-.7.7-.8 1.7-.6 2.7 0-.2.3-.1.3-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fc0",
    fillRule: "evenodd",
    d: "M460.8 281.3c-1 0-2.1.4-2.2 1v.9c0 .4.2.5.6.6.8.2 1.2-.8 1.4-1.6 0-.1 0-.6.2-.7l.4-.2-.3.3-.5 1.9c-.2.6-1.3.8-1.6.4-.5-.3-.6-1.7-.3-2 .7-.7 1.7-1 2.7-1-.2.1-.2.5-.4.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fc0",
    fillRule: "evenodd",
    d: "M460.6 281c-.3 0-.3.4-.1.6 0 .2.5.3.6.2.4-.2.6-.6.4-1-.2-.3-.6 0-.9.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fc0",
    fillRule: "evenodd",
    d: "M455.6 277.8s2.5 1 4.5 1c0 0 .1 1.8.5 2.3 0 0-1.8-.3-2.6 0 0 0-1.1-2.4-2.4-3.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M457.6 279s1 .4 1.8.4c0 0 0 .8.2 1 0 0-.7-.2-1 0 0 0-.4-1-1-1.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fc0",
    fillRule: "evenodd",
    d: "m460.8 282.9.6-1.1c0-.2 0 1 .4 1 .5.8.7 2.3.7 2.7-.7.2-1.3.6-2.3.2-.3-.3 0-1 0-1.4.2-.3.3-1 .6-1.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M461.3 282.2v.6c0-.2.3.2.3.3.3.7.5 1.1.6 2.4m-.7-2.2c.2 1 .4 1 .4 2.4v-.1m-.5-1.4.2 1.4-.3.2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fc0",
    fillRule: "evenodd",
    d: "m497.1 277.4.7-.6-21.4-23.7-.4.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fc0",
    fillRule: "evenodd",
    d: "M476.6 253c0-.9.6-2 1.2-2l.9.1c.3.1.4.3.5.6.1.9-1 1.2-1.7 1.3l-.8.1-.2.3.3-.1c.6-.2 1.2-.2 2-.3.5-.1.9-1.3.6-1.6-.3-.5-1.6-.8-2-.5-.8.5-1 1.5-1.2 2.5 0-.2.4-.1.4-.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fc0",
    fillRule: "evenodd",
    d: "M476.1 253.4c-.9-.3-2.1-.2-2.3.5l-.2.8c0 .4 0 .5.4.7.7.4 1.4-.5 1.7-1.2 0-.2.2-.6.4-.7h.4l-.3.2-1 1.7c-.2.5-1.4.5-1.7 0-.3-.4 0-1.7.3-2 .8-.6 1.8-.5 2.8-.2-.2 0-.3.3-.5.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fc0",
    fillRule: "evenodd",
    d: "M476 253c-.3 0-.3.4-.3.6 0 .2.4.4.6.3.4-.1.7-.4.6-.8-.1-.4-.6-.2-.9-.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fc0",
    fillRule: "evenodd",
    d: "M472 248.7s2 1.6 4 2c0 0-.3 1.9 0 2.4 0 0-1.7-.7-2.6-.5 0 0-.4-2.6-1.5-4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M473.6 250.4s.8.6 1.6.9v.9s-.7-.3-1-.2c0 0-.2-1-.6-1.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fc0",
    fillRule: "evenodd",
    d: "m475.7 254.9 1-1c0-.1-.4 1 0 1.3.4.8.1 2.3 0 2.7-.7 0-1.3.3-2-.4-.4-.3 0-.9.3-1.3 0-.3.4-1 .7-1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M476.4 254.4v.5l.2.7v2.2m-.3-2.5c.2.9 0 1.6-.1 2.5m0-1c-.2.4-.2.6-.2 1h-.3"
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c",
    width: "100%",
    height: "100%",
    transform: "matrix(-1 0 0 1 1030 0)"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fc0",
    stroke: "#000",
    strokeMiterlimit: 2.6,
    strokeWidth: 0.4,
    d: "m255.3 211-43 71.9h85.9z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#fff",
    strokeMiterlimit: 2.6,
    strokeWidth: 0.1,
    d: "m255.3 215.7-38.8 64.8H294z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#007e93",
    stroke: "#007e93",
    strokeMiterlimit: 2.6,
    strokeWidth: 0.2,
    d: "m228 261.3-11.5 19.2H294l-11.5-19.2z"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    strokeMiterlimit: 2.6,
    strokeWidth: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#086aad",
    d: "M248.5 227a10 10 0 0 1 6.7-2.3h.1c2.6 0 5.1.7 6.7 2.4"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#0863aa",
    d: "M248.5 227.1c1.7-1.6 4-2.3 6.6-2.3h.2c2.6 0 5.2.6 6.8 2.4"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#095fa8",
    d: "M248.4 227.3a9.3 9.3 0 0 1 6.8-2.5h.2c2.6 0 5.1.7 6.8 2.5"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#0a58a5",
    d: "M248.4 227.3a9.4 9.4 0 0 1 6.8-2.4h.2c2.6 0 5.2.7 6.8 2.5"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#0a52a2",
    d: "M248.3 227.4c1.8-1.8 4.3-2.4 7-2.5h.1c2.7 0 5.3.8 7 2.7"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#0b4d9f",
    d: "M248.3 227.5c1.7-1.8 4.2-2.5 7-2.5h.1c2.8 0 5.4.7 7 2.7"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#0c479d",
    d: "M248.2 227.6c1.8-1.9 4.3-2.5 7-2.5h.2c2.9 0 5.4.7 7.1 2.7"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#270a7f",
    d: "M247.7 228.4c2-2.2 4.6-2.8 7.6-2.8h.2c3.3 0 6 1.1 7.7 3.4"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#241183",
    d: "M247.8 228.3c2-2.1 4.5-2.8 7.5-2.8h.2c3.2 0 6 1.1 7.6 3.4"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#221786",
    d: "M247.8 228.2c2-2.1 4.5-2.7 7.5-2.7h.1c3.2 0 6 1 7.7 3.3"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#1f1f8a",
    d: "M247.9 228.1c2-2 4.4-2.7 7.3-2.7h.2c3.1 0 5.9 1 7.6 3.2"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#1a258d",
    d: "M248 228c1.8-2 4.3-2.6 7.2-2.6h.2c3 0 5.8.9 7.5 3"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#172d91",
    d: "M248 228c1.8-2 4.4-2.7 7.2-2.7h.2c3 0 5.7.8 7.4 3"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#143393",
    d: "M248 227.8a9.5 9.5 0 0 1 7.1-2.6h.2c3 0 5.7.8 7.4 3"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#113b97",
    d: "M248.1 227.7c1.8-1.9 4.3-2.5 7-2.5h.2c3 0 5.7.7 7.4 2.9"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#ff0a00",
    d: "M251 222.8a6.9 6.9 0 0 1 4.3-1.1c1.5 0 3 .3 4.2 1"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#f10",
    d: "M251 223a7 7 0 0 1 4.3-1.2c1.6 0 3 .2 4.2 1"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#ff1500",
    d: "M251 223a7.2 7.2 0 0 1 4.3-1.2c1.6 0 3 .3 4.3 1.1"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#ff1a00",
    d: "M250.9 223.1a7 7 0 0 1 4.4-1.2c1.6 0 3 .3 4.3 1"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#ff2000",
    d: "M250.8 223.2a7.1 7.1 0 0 1 4.4-1.2 8 8 0 0 1 4.5 1"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#ff2700",
    d: "M250.8 223.3a7.3 7.3 0 0 1 4.5-1.3c1.6 0 3.1.3 4.4 1.2"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#ff2f00",
    d: "M250.8 223.3a7.3 7.3 0 0 1 4.4-1.2 8 8 0 0 1 4.5 1.2"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#f30",
    d: "M250.7 223.4c1.3-1 2.8-1.3 4.6-1.3 1.6 0 3.2.4 4.5 1.2"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#ff3c00",
    d: "M250.7 223.5a7.3 7.3 0 0 1 4.6-1.3c1.6 0 3.3.3 4.5 1.2"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#ff4100",
    d: "M250.7 223.6a7.5 7.5 0 0 1 4.6-1.3c1.6 0 3.3.3 4.6 1.2"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#ff4600",
    d: "M250.6 223.6a7.5 7.5 0 0 1 4.7-1.3c1.7 0 3.3.4 4.6 1.2"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#fff500",
    d: "M249.6 225.3a9.9 9.9 0 0 1 5.7-1.7c2 0 4.2.6 5.7 1.7"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#ffeb00",
    d: "M249.7 225.2a9.6 9.6 0 0 1 5.6-1.6c2 0 4.2.5 5.6 1.7"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#ffe000",
    d: "M249.7 225.1a9.5 9.5 0 0 1 5.6-1.6c2 0 4.1.5 5.6 1.6"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#ffd600",
    d: "M249.8 225c1.4-1 3.6-1.6 5.5-1.6 2 0 4.1.5 5.5 1.6"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#ffcf00",
    d: "M249.8 225a9 9 0 0 1 5.5-1.7c2 0 4 .5 5.5 1.6"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#ffc400",
    d: "M250 224.8c1.3-1 3.4-1.6 5.3-1.6 2 0 4 .5 5.4 1.7"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#ffba00",
    d: "M250 224.7c1.4-1 3.4-1.5 5.3-1.5s4 .5 5.3 1.5"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#ffb000",
    d: "M250 224.6a9 9 0 0 1 5.3-1.5c1.9 0 3.9.5 5.3 1.5"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#ffa600",
    d: "M250 224.5a8.7 8.7 0 0 1 5.3-1.5 9 9 0 0 1 5.2 1.5"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#ff9c00",
    d: "M250.2 224.4a8.6 8.6 0 0 1 5.1-1.4c1.8 0 3.8.4 5.1 1.4"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#ff9100",
    d: "M250.2 224.4a8.6 8.6 0 0 1 5-1.5c2 0 3.8.4 5.2 1.4"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#ff8700",
    d: "M250.3 224.3a8.6 8.6 0 0 1 5-1.5 9 9 0 0 1 5 1.4"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#ff7d00",
    d: "M250.3 224.2a8.2 8.2 0 0 1 5-1.5 9 9 0 0 1 5 1.4"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#ff7500",
    d: "M250.4 224c1.3-1 3-1.3 4.9-1.3 1.7 0 3.6.4 5 1.3"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#ff6b00",
    d: "M250.4 224a8 8 0 0 1 4.9-1.4c1.7 0 3.5.4 4.8 1.3"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#ff6100",
    d: "M250.5 223.9c1.3-1 3-1.4 4.8-1.4 1.7 0 3.5.4 4.8 1.3"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#ff5700",
    d: "M250.5 223.8a7.8 7.8 0 0 1 4.8-1.4c1.7 0 3.4.4 4.7 1.3"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#ebf605",
    d: "M249.4 225.5a10 10 0 0 1 5.9-1.8c2 0 4.3.6 5.8 1.8"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#d6ec09",
    d: "M249.4 225.6a9.7 9.7 0 0 1 5.9-1.8c2 0 4.4.6 5.9 1.8"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#c2e30e",
    d: "M249.3 225.7a9.5 9.5 0 0 1 6-1.9c2.1 0 4.4.7 6 1.9"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#add912",
    d: "M249.3 225.8a9.4 9.4 0 0 1 6-1.9c2.1 0 4.5.7 6 2"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#99cf16",
    d: "M249.2 226a9.3 9.3 0 0 1 6-2c2.2 0 4.6.6 6.1 1.9"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#85c61a",
    d: "M249.2 226a9.3 9.3 0 0 1 6-2c2.3 0 4.7.7 6.2 2"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#70bc1f",
    d: "M249.1 226.1a9 9 0 0 1 6.2-2c2.2 0 4.6.7 6.1 2"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#5cb323",
    d: "M249 226.3a9 9 0 0 1 6.3-2.2c2.2 0 4.6.8 6.2 2"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#47a928",
    d: "M249 226.3a9 9 0 0 1 6.3-2c2.2 0 4.7.6 6.3 2"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#0d74a4",
    d: "M248.6 227c2-1.8 4.1-2.3 6.7-2.3 2.4 0 5 .6 6.6 2.2"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#127a97",
    d: "M248.7 226.9c1.9-1.7 4-2.3 6.6-2.3 2.4 0 5 .6 6.6 2.2"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#17808b",
    d: "M248.7 226.8c2-1.7 4-2.3 6.6-2.3 2.4 0 5 .7 6.5 2.2"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#1a847d",
    d: "M248.7 226.7c2-1.7 4-2.2 6.6-2.2 2.4 0 5 .7 6.5 2.2"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#1e8a6d",
    d: "M248.8 226.7c2-1.7 4-2.3 6.5-2.3 2.4 0 4.9.7 6.4 2.2"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#238f5e",
    d: "M248.8 226.6a9 9 0 0 1 6.5-2.2c2.3 0 4.8.7 6.4 2.1"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#2b944e",
    d: "M248.8 226.6a9 9 0 0 1 6.4-2.2c2.4 0 5 .7 6.5 2"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#2f9b3e",
    d: "M248.9 226.5c2.1-1.8 4-2.2 6.4-2.2 2.3 0 4.8.7 6.3 2.1"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "red",
    d: "M259.4 222.7a7.3 7.3 0 0 0-4.1-1 7 7 0 0 0-4.3 1"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#2a007c",
    d: "M263.3 229.2c-1.7-2.4-4.6-3.6-8-3.6-3 0-5.5.7-7.6 2.8"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#0671b0",
    d: "M262 227a9.3 9.3 0 0 0-6.7-2.3c-2.6 0-4.9.6-6.7 2.3"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#0c419a",
    d: "M262.6 228c-1.8-2.2-4.4-2.9-7.3-2.9-2.8 0-5.4.7-7.1 2.6"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#ff0",
    d: "M261 225.4a9.6 9.6 0 0 0-5.7-1.7c-2 0-4.3.6-5.8 1.7"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#ff4d00",
    d: "M260 223.6c-1.4-.8-3-1.2-4.8-1.2-1.7 0-3.3.3-4.6 1.3"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#33a02c",
    d: "M261.6 226.3a10 10 0 0 0-6.4-2c-2.4 0-4 .3-6.3 2.1"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    strokeMiterlimit: 2.6,
    strokeWidth: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#fef2ec",
    d: "M247.4 228.8a17.3 17.3 0 0 1 7.9-2c2.7 0 5.7 1.1 8 2.4l8.2 13.7c0 9-7.3 16.5-16.2 16.5-9 0-16.3-7.3-16.4-16.4l8.5-14.2z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#fef2ea",
    d: "M255.3 227c2.7 0 5.6 1.1 8 2.4l8 13.5c0 8.9-7.2 16.2-16 16.2a16.1 16.1 0 0 1-16.1-16.1l8.3-14a16.9 16.9 0 0 1 7.8-2z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#fef0e6",
    d: "M255.2 227.5c2.7 0 5.6 1 7.8 2.2l7.9 13.2a15.6 15.6 0 1 1-31.3.1l8.1-13.6a16.6 16.6 0 0 1 7.5-1.9z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#feede3",
    d: "M255.2 228c2.7 0 5.4 1 7.6 2.1l7.7 12.8c0 8.4-6.9 15.4-15.3 15.4A15.3 15.3 0 0 1 240 243c0-.2 7.8-13.1 8-13.2a16.1 16.1 0 0 1 7.2-1.9z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#fee8dc",
    d: "M255.2 228.6c2.5 0 5.2 1 7.3 2 .2.2 7.3 12 7.3 12.4a14.6 14.6 0 0 1-29.1 0c0-.3 7.3-12.5 7.5-12.6a15.4 15.4 0 0 1 7-1.8z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#fee6d5",
    d: "M255.2 229c2.5 0 5 1 7 2 .4.2 7.2 11.6 7.2 12 0 7.7-6.4 14.2-14.2 14.2a14.2 14.2 0 0 1-14-14.2c0-.4 7-12 7.2-12.3 2.1-1 4.3-1.7 6.8-1.7z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#fee3cf",
    d: "M255.2 229.7c2.4 0 4.8.9 6.7 1.9.4.2 6.8 10.9 6.8 11.3a13.5 13.5 0 0 1-27 0c0-.4 6.6-11.4 7-11.6 2-1 4.1-1.6 6.5-1.6z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#fee0cc",
    d: "M255.2 230.1c2.3 0 4.7.8 6.5 1.9.5.2 6.6 10.4 6.6 11 0 7.1-6 13-13 13a13 13 0 0 1-13.1-13c0-.6 6.3-11 6.7-11.3 2-1 4-1.6 6.3-1.6z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#fedec6",
    d: "M255.2 230.5c2.2 0 4.5.8 6.3 1.8.5.3 6.3 10 6.3 10.7 0 7-5.6 12.7-12.6 12.7a12.6 12.6 0 0 1-12.6-12.7c0-.6 6-10.6 6.5-11a13.4 13.4 0 0 1 6.1-1.5z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#fdcdaa",
    d: "M255.2 233.4c1.8 0 3.5.6 5 1.3.8.6 4.8 7.2 4.8 8.3a9.8 9.8 0 0 1-9.8 9.8 9.8 9.8 0 0 1-9.8-9.8c0-1 4.1-8 5-8.5a11 11 0 0 1 4.8-1.1z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#fdcdaa",
    d: "M255.2 233.6c1.7 0 3.4.5 4.8 1.3 1 .6 4.8 7 4.8 8.1a9.6 9.6 0 0 1-19.1 0c0-1.1 4-7.7 4.9-8.3a9.8 9.8 0 0 1 4.6-1.1z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#fdc59e",
    d: "M255.2 234.6c1.5 0 3 .5 4.3 1.2a20 20 0 0 1 4.2 7.2 8.5 8.5 0 0 1-8.5 8.5 8.5 8.5 0 0 1-8.5-8.4c0-1.4 3.3-6.8 4.4-7.4a8.5 8.5 0 0 1 4.1-1z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#fdc59e",
    d: "M255.2 234.8a8.3 8.3 0 0 1 4.2 1.2c1 .7 4 5.7 4 7a8.3 8.3 0 0 1-8.2 8.3 8.2 8.2 0 0 1-8.2-8.2c0-1.4 3-6.6 4.2-7.2a8.4 8.4 0 0 1 4-1z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#fef0e9",
    d: "M255.3 227.3c2.7 0 5.6 1 7.8 2.2l8 13.4a16 16 0 0 1-15.8 16 16 16 0 0 1-16-16l8.3-13.7a16.7 16.7 0 0 1 7.7-2z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#feede3",
    d: "M255.2 227.7c2.7 0 5.5 1 7.7 2.2l7.8 13a15.6 15.6 0 0 1-15.5 15.6 15.5 15.5 0 0 1-15.4-15.5c0-.2 7.9-13.4 8-13.4a16.1 16.1 0 0 1 7.4-1.9z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#feebdf",
    d: "M255.2 228.2c2.6 0 5.4 1 7.5 2 .2.2 7.6 12.5 7.6 12.8 0 8.2-6.8 15-15 15a15 15 0 0 1-15-15c0-.2 7.5-13 7.7-13a15.9 15.9 0 0 1 7.2-1.8z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#feebdd",
    d: "M255.2 228.4c2.6 0 5.3 1 7.4 2 .2.2 7.4 12.3 7.4 12.6a15 15 0 0 1-14.8 14.8 15 15 0 0 1-14.8-14.8c0-.3 7.5-12.7 7.7-12.9a15.8 15.8 0 0 1 7.1-1.7z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#fee8d9",
    d: "M255.2 228.8c2.5 0 5.1 1 7.2 2 .2.2 7.2 11.8 7.2 12.1a14.4 14.4 0 1 1-28.7 0c0-.2 7.1-12.2 7.4-12.4a15 15 0 0 1 7-1.7z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#fee6d3",
    d: "M255.2 229.3c2.4 0 5 .8 7 2 .3 0 7 11.2 7 11.6a14 14 0 0 1-14 14 14 14 0 0 1-13.9-13.9c0-.4 6.9-11.9 7.2-12a14.7 14.7 0 0 1 6.7-1.7z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#fee3d2",
    d: "M255.2 229.5c2.4 0 5 .8 6.8 1.9.4.2 7 11.1 7 11.5 0 7.6-6.2 13.8-13.8 13.8a13.8 13.8 0 0 1-13.7-13.7c0-.5 6.8-11.7 7.1-11.9a14.7 14.7 0 0 1 6.6-1.6z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#fee0cc",
    d: "M255.2 229.9c2.4 0 4.7.8 6.6 1.9.4.2 6.7 10.6 6.7 11.1 0 7.4-6 13.4-13.3 13.4A13.3 13.3 0 0 1 242 243c0-.5 6.4-11.3 6.9-11.5 2-1 4-1.6 6.3-1.6z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#fedec8",
    d: "M255.2 230.3c2.3 0 4.6.8 6.4 1.8.5.3 6.5 10.3 6.5 10.9a12.8 12.8 0 0 1-25.7 0c0-.6 6.2-10.9 6.6-11.1a13.4 13.4 0 0 1 6.2-1.6z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#fddbc5",
    d: "M255.2 230.8c2.2 0 4.4.7 6.2 1.7.5.3 6.2 9.8 6.2 10.5 0 6.8-5.6 12.5-12.4 12.5A12.4 12.4 0 0 1 243 243c0-.7 5.8-10.4 6.3-10.7a13 13 0 0 1 6-1.5z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#fddbc2",
    d: "M255.2 231a13 13 0 0 1 6 1.7 72 72 0 0 1 6.2 10.3 12.2 12.2 0 0 1-24.4 0c0-.7 5.8-10.2 6.4-10.6a13 13 0 0 1 5.8-1.4z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#fdd9bf",
    d: "M255.2 231.2c2.1 0 4.3.7 6 1.7.6.3 6 9.3 6 10a12 12 0 0 1-12 12.1 12 12 0 0 1-12-12c0-.8 5.7-10 6.2-10.4a12.7 12.7 0 0 1 5.8-1.4z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#fdd9bf",
    d: "M255.2 231.4c2 0 4.2.7 5.9 1.7.6.3 5.9 9.1 5.9 9.9a11.8 11.8 0 0 1-11.8 11.8c-6.4 0-11.7-5.2-11.7-11.8a65 65 0 0 1 6-10.2c1.8-.9 3.6-1.4 5.7-1.4z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#fdd6bc",
    d: "M255.2 231.6c2 0 4.1.7 5.8 1.7.6.3 5.7 8.9 5.7 9.7 0 6.3-5.2 11.6-11.5 11.6a11.6 11.6 0 0 1-11.5-11.6 56 56 0 0 1 6-10c1.7-.9 3.5-1.4 5.5-1.4z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#fdd6b9",
    d: "M255.2 231.8c2 0 4 .7 5.7 1.6.7.4 5.6 8.7 5.6 9.6 0 6.2-5 11.4-11.3 11.4A11.3 11.3 0 0 1 244 243c0-.9 5.1-9.4 5.9-9.8a11.7 11.7 0 0 1 5.4-1.4z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#fdd4b8",
    d: "M255.2 232c2 0 4 .7 5.6 1.6a48 48 0 0 1 5.5 9.4c0 6-5 11.2-11 11.2A11.1 11.1 0 0 1 244 243c0-.9 5-9.2 5.7-9.6a11 11 0 0 1 5.4-1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#fdd4b6",
    d: "M255.2 232.3c2 0 4 .6 5.5 1.5.7.5 5.4 8.3 5.4 9.2a10.9 10.9 0 1 1-21.7 0c0-1 4.8-9 5.6-9.4a11.5 11.5 0 0 1 5.2-1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#fdd2b2",
    d: "M255.2 232.5c2 0 3.8.6 5.4 1.5.7.4 5.3 8 5.3 9 0 5.9-4.8 10.7-10.7 10.7a10.7 10.7 0 0 1-10.6-10.7c0-1 4.7-8.7 5.5-9.2 1.5-.8 3.2-1.3 5.1-1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#fdd1b0",
    d: "M255.2 232.7c1.9 0 3.8.6 5.2 1.5a36 36 0 0 1 5.3 8.8 10.5 10.5 0 0 1-10.5 10.5c-5.7 0-10.4-4.7-10.4-10.5 0-1 4.5-8.6 5.4-9a10.5 10.5 0 0 1 5-1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#fdd0b0",
    d: "M255.2 233c1.8 0 3.7.5 5.1 1.4a31 31 0 0 1 5.1 8.6c0 5.6-4.5 10.3-10.2 10.3A10.3 10.3 0 0 1 245 243c0-1 4.4-8.3 5.3-8.8a10.4 10.4 0 0 1 5-1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#fdd0ad",
    d: "M255.2 233.1c1.8 0 3.6.6 5 1.4 1 .6 5 7.4 5 8.5 0 5.5-4.5 10-10 10s-10-4.4-10-10c0-1 4.3-8.1 5.2-8.6a10.2 10.2 0 0 1 4.8-1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#fdcaa6",
    d: "M255.2 233.8c1.7 0 3.4.5 4.7 1.3 1 .6 4.7 6.7 4.7 8a9.4 9.4 0 0 1-9.4 9.3 9.3 9.3 0 0 1-9.3-9.3 25 25 0 0 1 4.8-8.2 9.7 9.7 0 0 1 4.5-1.1z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#fdcaa4",
    d: "M255.2 234a9.7 9.7 0 0 1 4.6 1.3 23 23 0 0 1 4.5 7.7 9.2 9.2 0 0 1-9 9.2 9.2 9.2 0 0 1-9.2-9.1 24 24 0 0 1 4.7-8 9.5 9.5 0 0 1 4.4-1.1z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#fdc8a4",
    d: "M255.2 234.2c1.6 0 3.2.5 4.5 1.3 1 .6 4.4 6.3 4.4 7.5 0 5-4 9-8.9 9s-8.9-4-9-9c0-1.2 3.7-7 4.7-7.7a9 9 0 0 1 4.3-1z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#fdc8a1",
    d: "M255.2 234.4c1.6 0 3.1.5 4.4 1.3 1 .6 4.3 6 4.3 7.3a8.8 8.8 0 0 1-8.7 8.8 8.7 8.7 0 0 1-8.7-8.7c0-1.4 3.4-7 4.5-7.6a9 9 0 0 1 4.2-1z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#fdc39b",
    d: "M255.2 235c1.5 0 3 .5 4 1.2 1.2.7 4 5.4 4 6.8a8 8 0 0 1-8 8 8 8 0 0 1-8-8c0-1.4 3-6.3 4-7a8.2 8.2 0 0 1 4-1z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#fdc398",
    d: "M255.2 235.3c1.4 0 2.8.4 4 1 1.1.8 3.8 5.3 3.8 6.8 0 4.3-3.5 7.8-7.8 7.8a7.8 7.8 0 0 1-7.8-7.8 15 15 0 0 1 4-6.9c1.1-.5 2.4-1 3.8-1z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#fdc097",
    d: "M255.2 235.5a8 8 0 0 1 3.9 1c1.2.8 3.7 5 3.7 6.6 0 4.1-3.4 7.6-7.6 7.6a7.6 7.6 0 0 1-7.6-7.6c0-1.6 2.7-6 4-6.7a7.7 7.7 0 0 1 3.6-.9z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#fdc095",
    d: "M255.2 235.7a8 8 0 0 1 3.8 1c1.2.8 3.6 4.8 3.6 6.4a7.4 7.4 0 0 1-7.4 7.4 7.4 7.4 0 0 1-7.4-7.4 12 12 0 0 1 3.8-6.4 7.3 7.3 0 0 1 3.6-1z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#fdbe92",
    d: "M255.2 236c1.3 0 2.6.4 3.7 1 1.2.7 3.5 4.5 3.5 6a7.2 7.2 0 1 1-14.4 0 12 12 0 0 1 3.7-6.2 7.5 7.5 0 0 1 3.5-.9z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#fdbe90",
    d: "M255.2 236.1c1.3 0 2.5.4 3.5 1 1.3.8 3.4 4.4 3.4 6a7 7 0 0 1-6.9 7 7 7 0 0 1-7-7c0-1.7 2.3-5.3 3.6-6a7 7 0 0 1 3.4-1z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#fdbb8f",
    d: "M255.2 236.3c1.2 0 2.4.4 3.4 1 1.3.8 3.4 4.1 3.4 5.8a6.7 6.7 0 0 1-13.5 0c0-1.7 2-5.1 3.4-5.9 1-.5 2.1-.8 3.3-.8z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#fdbb8d",
    d: "M255.2 236.6a7 7 0 0 1 3.3.9 9 9 0 0 1 3.2 5.6 6.5 6.5 0 0 1-6.5 6.5 6.5 6.5 0 0 1-6.5-6.5 9 9 0 0 1 3.3-5.7c1-.5 2-.8 3.2-.8z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#fdb98a",
    d: "M255.2 236.8a6.2 6.2 0 0 1 3.2.9 8 8 0 0 1 3.1 5.4 6.3 6.3 0 0 1-6.3 6.3 6.3 6.3 0 0 1-6.3-6.3c0-1.8 1.8-4.7 3.2-5.5a6.4 6.4 0 0 1 3.1-.8z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#fdb98a",
    d: "M255.2 237c1.1 0 2.2.4 3 .9a7 7 0 0 1 3 5.2 6.1 6.1 0 0 1-6 6 6 6 0 0 1-6-6c0-1.8 1.6-4.5 3-5.3a5.8 5.8 0 0 1 3-.8z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#fcb687",
    d: "M255.2 237.2a6 6 0 0 1 3 .9 6.9 6.9 0 0 1 2.9 5 5.9 5.9 0 1 1-11.8 0 6.8 6.8 0 0 1 3-5.1 5.8 5.8 0 0 1 3-.8z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#fcb685",
    d: "M255.2 237.4a5.6 5.6 0 0 1 3 .8c1.4 1 2.7 3 2.7 4.9a5.6 5.6 0 0 1-5.7 5.6 5.7 5.7 0 0 1-5.6-5.6 6.3 6.3 0 0 1 2.9-5 5.4 5.4 0 0 1 2.7-.7z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#fcb485",
    d: "M255.2 237.7c1 0 2 .3 2.8.7a5.7 5.7 0 0 1 2.6 4.7 5.4 5.4 0 1 1-10.8 0 5.7 5.7 0 0 1 2.7-4.7 5.3 5.3 0 0 1 2.7-.7z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#fcb482",
    d: "M255.2 248.3a5.2 5.2 0 0 0 0-10.4 5.2 5.2 0 0 0-5.2 5.2 5.2 5.2 0 0 0 5.2 5.2z"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    stroke: "#fff",
    strokeMiterlimit: 2.6,
    strokeWidth: 0.1,
    d: "M255.3 248.3a5.2 5.2 0 1 0-5.3-5.2 5.2 5.2 0 0 0 5.3 5.2z"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    stroke: "#000",
    strokeWidth: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "m256.4 238 .6-2.8m-1.2 2.7.3-2.8m-.8 2.8V235m-.6 2.8-.3-2.8m-.2 2.9-.6-2.8m0 3-.8-2.8m.3 3-1.1-2.7m.7 2.8-1.5-2.4m1 2.7-1.7-2.2m1.3 2.6-2-2.1m1.6 2.5-2.1-2m1.7 2.4-2.3-1.6m2 2-2.4-1.3m2.2 1.9-2.6-1.2m2.4 1.7-2.7-1m2.5 1.5-2.7-.6m2.6 1.1-2.8-.3m2.8.9h-2.8m2.8.5-2.8.3m3 .3-2.9.6m3-.1-2.7.9m2.9-.4-2.6 1.2m2.8-.7-3 1.8m3.3-1.3-6.1 4.3m6.4-4-6.5 5.9m6.9-5.4-5.4 6m5.9-5.7-4.2 5.5m4.6-5.2-4.3 7.5m4.8-7.2-2.4 5.4m2.9-5.2-2.4 7.4m3-7.3-1.1 5m1.6-4.9-.8 7.7m1.8-7.7.3 2.8m.3-2.9 1.7 7.3m-1.2-7.4 1.4 4.3m-.9-4.5 3.3 7.1m-2.7-7.4 3.5 6.1m-3.1-6.4 5 6.7m-4.6-7 4.5 5.2m-4-5.6 6.5 6m-6.3-6.4 3.6 2.6m-3.2-3 2.4 1.4m-2.2-2 2.6 1.2m-2.4-1.6 2.7.8m-2.5-1.4 2.7.6m-2.7-1.1 2.9.3m-2.8-.9h2.8m-2.9-.5 2.9-.3m-3-.2 2.9-.6m-3 0 2.7-.8m-2.9.3 2.6-1.1m-2.8.6 2.5-1.4m-2.8 1 2.3-1.7m-2.7 1.2 2.2-1.9m-2.5 1.6 1.9-2.2m-2.4 1.8 1.7-2.3m-2.1 2 1.4-2.5m-1.9 2.3 1.2-2.6m-1.7 2.3.9-2.6m-2.5-4.3V229m-2.5 2.4-.4-2.1m-2 2.9-.8-2m-1.3 3.2-1.3-1.8m-.5 3.4-1.7-1.4m.2 3.5-2-1.1m1 3.3-2.1-.7m1.5 3.1-2.1-.2m2.1 2.7-2.1.2m2.7 2.3-2.1.6m23.6 1.7 2 1m-1-3.3 2 .7m-1.5-3.1 2.2.2M267 242l2.2-.2m-2.7-2.2 2.1-.7m-3-1.6 1.8-1.1m-3.3-.9 1.6-1.5m-3.4-.1 1.2-1.8m-3.4.5.9-2m-3.3 1.2.5-2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e60000",
    fillRule: "evenodd",
    strokeMiterlimit: 2.6,
    d: "M258.3 245.5s-.7-.4-1.2-.4l-3.2.1-.8.6s.5.5 1.6.6a5.8 5.8 0 0 0 2.3-.2c.6-.2 1.3-.7 1.3-.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e60000",
    fillRule: "evenodd",
    strokeMiterlimit: 2.6,
    d: "M253.3 244.8s0-1.5 1-3.3l-.5 1s-.5.3-.9-.1c-.3-.4-.1-.5.1-1 .3-.4.2-.9.5-1.1.3-.3.5-.3 1.2-.3s1.1 0 1.7.9c.6.7.9 1.3 1.1 1.7.6 1 .6 2 .6 2l.2 1s-.7-.5-1.2-.5l-3.2.1-.8.6s-.3-.7.2-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeMiterlimit: 2.6,
    d: "M253.3 244.8s.5-.4 2.4-.3c2.2 0 2.3.1 2.4.3"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fc0",
    fillRule: "evenodd",
    strokeMiterlimit: 2.6,
    d: "M255.1 253v-7.8s.3-.2.9 0v7.6s.2 5.8-.5 5.8-.4-1.3-.4-5.7z"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    fill: "#e60000"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "m247.2 246.5.2.3-1.5.6.2.5h-.2c-.2-.2-.3-.4-.6-.3l-.1-.2 2-1zm-1.6-.7a.7.7 0 0 1-.2-.4c-.1-.3 0-.7.5-.9.2 0 .8 0 1 .7 0 .3 0 .6-.5.8v-.3c.2 0 .3-.3.2-.5 0-.3-.3-.4-.6-.4-.3.1-.4.4-.4.6a.5.5 0 0 0 .4.4v.2l-1.3.1-.2-1.1h.3l.2.9h.6zm-.6-4.1c-.3 0-.5.3-.5.5s0 .6.3.6.3-.1.4-.3l.2-.6c0-.3.3-.5.6-.5.6 0 .7.6.7 1s-.2.6-.3.7c-.2.1-.4.2-.6.1v-.3c.4 0 .6-.3.6-.5 0-.3 0-.6-.3-.7-.3 0-.4.1-.5.5l-.1.5c0 .1-.2.4-.6.4-.4 0-.7-.3-.7-.9.1-.8.6-.8.8-.8v.3zm0-1.4.6.2.4-1.3.3.2-.4 1.1.7.3.4-1.3h.3l-.5 1.7-2.2-.7.5-1.7.3.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.4 236.8a.8.8 0 0 0-.4.4l-.5.9 2 1.2.1-.3-.8-.5.3-.6c.3-.5.1-.8-.2-1a.6.6 0 0 0-.4 0zm.2.4a.5.5 0 0 1 .1 0c.3.2.3.4.1.6l-.3.5-.6-.4.3-.5.4-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "m249.2 237-.2.2-1.5-1.4-.6.5-.2-.2 1.3-1.3.3.1-.6.6zm.7-.7-1.3-1.9.2-.1 1.4 1.8zm0-2.5.3.7 1.2-.6v.2l-1 .6.3.7 1.3-.6v.2l-1.4.8-1.1-2 1.5-.8.1.2zm4.3.7-.3-1.4-.1-.5-.2 2h-.3l-1.1-1.7.1.6.3 1.3h-.3l-.5-2.2h.5l1 1.7.3-2 .4-.2.5 2.3h-.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m255 232.1-.1 2.3h1c.5 0 .8-.2.8-.6 0-.4-.3-.5-.4-.6a.5.5 0 0 0 .3-.4c0-.4-.2-.6-.6-.7h-1zm.3.3h.5c.3 0 .5.2.5.4 0 .3-.2.3-.5.3h-.6l.1-.7zm0 1h.5c.2 0 .5.1.5.4 0 .2-.2.4-.5.4h-.6v-.8zm2.2-1-.6 2.2h.3l.3-.9.7.2c.4.1.3.3.3.5l-.1.6h.4c-.1 0 0 0 0-.2v-.4c.1-.3 0-.4-.1-.5.1 0 .4-.1.5-.4 0-.5-.2-.7-.6-.8l-1-.4zm.3.3.7.3c.2 0 .4 0 .3.4-.1.3-.3.3-.5.2l-.7-.2.2-.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "m260.3 233.7-.4.6 1.1.6-.1.2-1.1-.6-.4.7 1.2.7-.1.2-1.5-.9 1.1-2 1.5.9-.1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m263 235.4-1.7 1.4.6.8c.5.5 1.2.3 1.6 0 .5-.5.6-1 .2-1.5l-.6-.7zm0 .5.4.4c.3.3.2.6-.2 1-.4.3-.7.3-1 0l-.4-.4 1.3-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "m264.7 238-.7.3.6 1-.2.2-.6-1.1-.7.3.6 1.3h-.2l-.8-1.4 2-1 .9 1.5h-.3zm-.8 4.1v-.3l1.5-.2v-.5h.2c0 .3.1.4.5.4v.3l-2.2.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.6 242.8c-.1 0-.3 0-.5.2a1 1 0 0 0-.2.6c0 .5.3.8.7.8.1 0 .4 0 .5-.4 0 .1.2.3.5.3s.6-.1.6-.6c0-.6-.3-.8-.6-.8-.2 0-.4.1-.4.4-.1-.3-.3-.5-.6-.5zm0 .4c.2 0 .4.1.4.4 0 .3-.1.4-.4.4-.4 0-.4-.2-.4-.4 0-.4.2-.4.4-.4zm1 0c.2 0 .3.2.3.5s-.2.3-.3.3a.4.4 0 0 1-.3-.4c0-.2.1-.3.3-.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M265.3 244.8c.7.2.7.8.6 1 0 .4-.4.6-.8.5-.4 0-.5-.3-.6-.8l-.1-.2c0-.3-.2-.5-.3-.5l-.3 1.2h-.3l.4-1.6c.5.2.7.4.8.8v.3c.1.3.2.5.5.5.1 0 .4 0 .5-.3 0-.4-.3-.5-.5-.6v-.3zm-2.3 2.3.2-.3 1.4.7.2-.5h.3c-.2.4-.2.6 0 .8v.2l-2-1z"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 2.6,
    strokeWidth: 0.3,
    d: "m255.3 215.7-38.8 64.8H294z"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    strokeMiterlimit: 2.6
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M257.3 272.5c1 .3 2.2.4 3.5.1 1.6-.4 3.2-1.4 5.1-1.2 1.5.2 3.4 1.4 5.7 1.4 2.3 0 3-.8 5-1.2 1.5-.3 2.2-.2 3.7.1 1.8.4 2.6 1.4 5.6 1.2"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeWidth: 0.4,
    d: "M227.4 275.3a7 7 0 0 1 5.4-1c2.3.5 3.3 1 5.7 1 1.8 0 3.4-1.2 5.2-1.2 3.1 0 3.2.6 6 1.1a6 6 0 0 0 2.2 0c1-.1 2-.5 2.7-.9.9-.4 3-.4 4.1-.3 2 .2 2.7 1 3.1 1 1 .4 2.2.5 3.4.2 1.7-.5 3.3-1.6 5.3-1.4 1.4.2 3.3 1.6 5.6 1.6s3.1-1 5-1.4c1.5-.4 2.2-.2 3.7.2 1.7.4 2.7 1.5 5.6 1.2"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeWidth: 0.3,
    d: "M223 273.1a8 8 0 0 1 5.4-.9c2.3.5 3.3 1 5.8 1 1.8 0 3.3-1.1 5.2-1.1 3 0 3.2.6 5.9 1h2.3a10 10 0 0 0 2.7-.9c.8-.3 3-.3 4-.2 2 .2 2.7.8 3.1 1 1 .2 2.3.3 3.5 0 1.7-.4 3.2-1.4 5.2-1.2 1.4.2 3.3 1.4 5.6 1.4s3.1-.8 5.1-1.3c1.4-.3 2.1 0 3.7.2 1.7.4 2.6 1.4 5.5 1.1"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeWidth: 0.5,
    d: "M219 279.5a6.8 6.8 0 0 1 5.5-1.2c2.2.6 3.2 1.3 5.7 1.2 1.8 0 3.4-1.4 5.2-1.4 3 0 3.2.7 5.9 1.3a6.2 6.2 0 0 0 2.3 0 9 9 0 0 0 2.7-1c.8-.5 3-.4 4-.3 2 .2 2.7 1 3.1 1.1a6.5 6.5 0 0 0 3.5.1c1.7-.5 3.2-1.7 5.2-1.5 1.4.2 3.3 1.7 5.7 1.7 2.2 0 3-1 5-1.5 1.4-.4 2.1-.2 3.7.2 1.7.5 2.6 1.7 5.5 1.4"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeWidth: 0.3,
    d: "M220.1 275.8c1.4-.9 3.7-1.2 5.4-.9 2.3.5 3.3 1 5.7 1 .8 0 1.6-.3 2.4-.5"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 0.3,
    d: "M231.8 272c.4 0 1.5-.6 3-.6 3.2 0 1.2 0 3.9.5.7.2 2.7.2 3.2-.4m27.1 8.8 2.7-.8c.8-.4 3-.4 4.1-.3 2 .2 2.7.8 3.1 1 1 .2 2.2.3 3.5 0 1.6-.4 3.2-1.4 5.2-1.2 1.4.2 3.3 1.4 5.6 1.4"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeWidth: 0.3,
    d: "M273.8 271.8c2.3 0 3-.9 5-1.3 1.5-.3 2.2 0 3.7.2 1.7.3 2.6 1.4 5.6 1.1"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M219.2 279.7a8.2 8.2 0 0 1 5.4-1c2.3.5 3.3 1 5.7 1 1.8 0 3.4-1 5.2-1 3 0 3.2.5 5.9 1a8 8 0 0 0 2.3 0 8 8 0 0 0 2.7-1c.8-.3 3-.2 4 0 2 0 2.7.7 3.2.8"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 0.5,
    d: "M224 276.9a8 8 0 0 1 5.5-1c2.3.5 3.3 1 5.7 1 1.8 0 3.4-1.1 5.2-1.1 3 0 3.2.6 5.9 1h2.3c1-.2 1.8-.4 2.7-.8.8-.4 3-.4 4-.2 2 .1 2.7.8 3.2.8 1 .3 2.2.4 3.4.1 1.7-.4 3.2-1.4 5.2-1.2 1.6.2 3.5 1.4 5.7 1.4 2.3 0 3-.8 5-1.2 1.4-.3 2.1-.2 3.7.2 1.7.3 2.6 1.3 5.5 1"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    fill: "#fc0",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M225.1 266c.4.2 1.3-.6 1.5-.7.4-.3.6-.8.9-1.1l1.6-1a11.5 11.5 0 0 0 3.8-3.4 19 19 0 0 1 6-5.5c.9-.5 2-.3 2.9 0l.9.7a12 12 0 0 0 4.1 1.9c1.7.5 2 1.6 3.3 2.7a9.1 9.1 0 0 0 2.1 1.4l.4.4 2.1 1.5a71.4 71.4 0 0 1 3.4 3.3c.2.2.3.6.5.7.8.9 1.7 1.7 2.7 2.2l3 1.8c-10 .3-19-.3-28.9 0h-13.1l2.8-4.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m263.8 270.6-2.5-1.5c-1-.5-1.9-1.3-2.7-2.2-.2-.1-.3-.5-.4-.7a71.5 71.5 0 0 0-3.4-3.3l-2.2-1.5-.4-.4a9.1 9.1 0 0 1-2-1.4c-1-.8-1.4-1.5-2-2 .4-.4.8-.7 1.3-.9.6-.3 1.6-.2 2.3.1.2 0 .5.3.8.5a9 9 0 0 0 3.4 1.6c1.4.4 1.7 1.3 2.8 2.2.5.5 1 1 1.7 1.2l.3.4c.6.4 1.3.8 1.8 1.3 1 .8 2 1.7 2.9 2.7l.3.6c.7.6 1.4 1.3 2.3 1.8l2.4 1.4-6.6.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m255 258.6 1 .3c1.4.4 1.7 1.3 2.8 2.2.5.5 1 1 1.7 1.2l.3.4c.6.4 1.3.8 1.8 1.3a64.7 64.7 0 0 1 2.8 2.7c.2.1.2.4.4.6.7.6 1.4 1.4 2.3 1.8.7.3 1.3.8 2 1.2l5.5-.1-2.2-1.4c-.8-.3-1.4-1-2-1.6l-.4-.5c-.8-1-1.7-1.7-2.6-2.5l-1.6-1.2-.3-.3a6.7 6.7 0 0 1-1.5-1c-1-.9-1.3-1.7-2.6-2a9.7 9.7 0 0 1-3-1.5l-.7-.5c-.7-.3-1.6-.4-2.2 0a10.5 10.5 0 0 0-1.5 1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m264 260.7 1 1c.4.4 1 .7 1.5 1l.3.3 1.6 1.2c1 .8 1.8 1.6 2.6 2.5l.4.5c.6.6 1.2 1.3 2 1.6l1.4.9 6.5-.1c-.6-.4-1.1-.8-1.8-1l-1.7-1.4-.2-.4-2-2-1.4-1-.3-.2a6 6 0 0 1-1.3-.9c-.7-.7-1-1.3-2-1.6a7.8 7.8 0 0 1-2.5-1.2l-.5-.4c-.6-.2-1.3-.3-1.8 0a10.2 10.2 0 0 0-1.7 1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.8 269.3a7.8 7.8 0 0 0-1.3-.8c-.6-.3-1-.8-1.7-1.3l-.2-.4-2-2-1.4-1-.2-.2a6.2 6.2 0 0 1-1.3-.9c-.7-.6-1-1.1-1.6-1.5a6.7 6.7 0 0 1 1-.7c.5-.2 1.1-.1 1.6 0l.4.4a9 9 0 0 0 2.2 1c.9.3 1 .8 1.7 1.4.4.3.7.6 1.1.7l.2.3 1.2.8 1.7 1.7c.2.1.2.3.3.4.4.4.9.8 1.4 1l1.5 1h-4.6v.1z"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#00633b",
    strokeWidth: 0.1,
    d: "M238 254.9c.5 0 .3-.2.7.1m-1.6.5c.6 0 .7-.4 1.1 0m-1.5.3c.2 0 .3-.2 1 .2m-1.5.4 1.1.1m-1.7.4c.5-.2.7.2 1.3 0m-2 .6c.4 0 .5-.1.8 0h.6m-2 .7h1.5m-2 .5c.8 0 1 0 1.5.2m-2.5 1.2a2 2 0 0 1 1.5 0m-11.8 10.6c2-.4 4.5 0 6.5-.3m4.1-11c.5-.2.4 0 1 0 .5 0 .7.1.8 0m-2.6 1.2c.5-.3 1.1-.1 1.7 0m-.4.6c-.5-.2-1.1 0-1.7 0m1.3.6a3 3 0 0 0-1.8-.1m-.8.5c.7 0 1.4-.2 2.1 0m-2.8.6c.8-.3 1.6 0 2.4 0m-3.1.4h2.9m-.2.5c-1.3.2-2.5 0-3.7 0m3 .6-1.6.2-.3-.2a4.4 4.4 0 0 0-1.9.2m-.3.5c.3-.2.6-.2.9-.1l2.2.1.6.2m-4 0 1.6.1 2 .4m-4.2 0a5 5 0 0 1 1.7.2l2.3.1m-4.7 0c.8.4 1.6 0 2.4.2.8.2 1.5.1 2.2.3m-5.1.1c1.1 0 2.3 0 3.6.3.3 0 .8.2 1.3.1m-5.3.2c1.1.2 2.3 0 3.4.3l1.7.2h-.1m-5.5.3h3.1c.8 0 1.6-.1 2.3.1m-5.8.5h5.6m-6 .6c2 .2 4 0 5.9.2m-6.2.4c.9.2 1.7 0 2.6.1.6.1 1.2.2 1.8.1.6-.1 1 0 1.6 0m8-8.1h.1m-.4.2h.3m-.5.3h.4m-.6.2h.5m-.8.4h.8m-1 .4h1-.1m-1.4.5h1.4-.1m-1.6.4h1.5m-1.8.4 1.8.1m-2 .5 1 .2c.2.1.5 0 .8 0m-2 .2c.6.2 1.1.2 1.7.2m-2 .2 1.4.2h.6m-2.7.5c.6-.2 1.3 0 2 .1h.7-.1m-2.6.4a3 3 0 0 1 2 0h.4m-2.9.5c1 .2 2-.1 2.8.1m-3 .3c.7.3 1.5 0 2.3.2.3.1.5.1.8 0m-3.7.4c.4-.2.7-.2 1-.2 1 .3 1.7.2 2.6.3m-4 .4.6.1c1.1-.2 2.3 0 3.4 0m-4.2.4c.8.3 1.8 0 2.7.2.4.1.9.2 1.3 0m-4.4.4c1.4 0 2.7 0 4.3.2m3.5-8h.4m-.6.4h.5m-.6.3.7.1m-1 .5h1m-1.2.5h1.2m-1.2.3c.3.2.7 0 1.1.1m-1.4.5 1 .1h.5m-1.5.5c.5-.2 1 0 1.5 0m-1.7.6h1.6m-1.8.5c.2-.1.5-.3.7-.1h1.1m-2 .6c.7-.2 1.4.2 2-.2m-2 .8a1.6 1.6 0 0 1 1 0h1m-2.2.6c.8-.2 1.6 0 2.3 0m-2.7.5 3-.2m-2.9.8c1-.2 2.2-.1 3.3-.2m-3.5.8c1 .1 1.3 0 2.4-.1l1.3-.3h.6m-4.3.7c1.6-.2 3.3.1 5-.3m-12 .1h1.2m5 .2h.5m5.7-.1c1.4-.2 2.7.2 4 0m-4.6-.5c.8-.2 1.6 0 2.4.1l.1.2h2.2m-9.5-.4h-.8m-4.5-.1h-1.8m13-12.5h.2m-.1.4h.3m-.3.5h.5m-.3.4h.6m.1.3c-.2 0-.4 0-.6.2m.3.5a.8.8 0 0 1 .6-.1m.2.4h-.8m.2.5.8-.1m.3.6h-1m.3.6c.3 0 .6 0 1-.2m0 .4-1 .2m.3.6c.4-.3.9 0 1.3-.2m0 .5h-1l-.3.1m.3.9c.3-.1.5-.3.8-.3 0-.2.2 0 .3-.1h.4m.2.5-1.5.2m.1.6 1.7-.3m-1.6 1c.6-.1 1.3 0 1.9-.3m.4.4c-.7.1-1.4 0-2 .3m0 .7h.4a4.3 4.3 0 0 1 2-.4m.2.5c-.7.4-1.5.2-2.2.3h-.3m.3.5 2.4-.2m.5.5-2 .1-.8.2m.1.5h.4c.8-.5 1.7-.3 2.6-.4m.2.6c-.7 0-1.5-.2-2.2 0-.3.1-.5.3-.8.3m.2.5 1.2-.3h2.5m0 .4h-1.4c-.7.2-1.4.4-2.2.4m.4.4c.6 0 1.2-.3 1.8-.4h1.4m-3.1.7c.9-.1 1.8 0 2.7-.3h1m0-.3c1.4.1 2.9-.2 4.3.2m-4 .3.4-.1h3.6m-.4-3h.2m-.2.3c.2.1.3-.2.5 0m-.3.5h.7m-.5.6c.2-.3.6 0 .9-.2m-.7.8c.3-.3.8 0 1.1-.3m-1 .7c.4-.1 1 0 1.4-.2m-1.3.7c.8-.3 1.6.1 2.3-.4m-2.2.8c1-.3 1.9 0 2.8 0m.6 0c1.6-.1 3.3-.2 5 0m-5.7-.7c1.5.2 3.6 0 5.5.2M249.7 259l1.2-.2m-.9.4 1.3-.1m-.8.6 1-.2h.3m-1 .5h1.7m.2.2c-.2 0-1.1 0-1.3.2m.8.5a3.3 3.3 0 0 1 1.1-.2m.6.4h-1.3m.7.6 1-.3m.7.5-1.3.1m.6.5 1.3-.1m.4.2c-.2.2-.7.2-1 .3m.5.5c.3-.2.9 0 1.3-.2m.5.5h-1.1l-.4.1m2.8.8-1.6.2m.5.6c.5-.3 1.2-.2 1.7-.3m-.4 1.8h.8c.9-.2 1-.4 1.8-.3m.5.3a27.2 27.2 0 0 1-2.7.4m.5.4c.8-.2 2-.1 2.8-.2m.9.4c-.7.1-1.5 0-2.1.2l-1.1.1m.7.5h.4c.6-.5 1.7-.4 2.6-.4m.7.5h-2l-1 .3m.8.4 1.5-.2h2m.2.3a4.7 4.7 0 0 0-1.6 0c-.4.1-.3.2-1.5.3m.5.2c.6 0 .7 0 1.2-.2h1.6m-2.5.4h2.8m-17.2-11.7c.2 0 .4-.2.8-.1-.1-.2.2 0 .3-.1h.3m-1.8-.2.8-.1c-.1-.2.2 0 .2-.1h.4m6 6.4c.2-.1.2-.2.5-.1 0-.2.4 0 .5-.1h.6m-.1 1.7 1.8-.4m1 .6c-.8.1-1.8 0-2.4.4m-8.4-9c-.7 0-.8.2-1.3.2m8.6 1.7 1-.2m-.7.5c.4-.1.8 0 1-.2m-.7.6.8-.1h.4m-.8.4 1.4-.1m.2.3a4.5 4.5 0 0 0-1.3.2m.5.4a3.9 3.9 0 0 1 1.4-.2m.5.4-1.4.1m.5.4c.3 0 1.2 0 1.3-.2m.5.5h-1.2m.4.5c.4 0 1.2 0 1.4-.2m.4.3-1.2.3m.7.4c.3-.2.9-.1 1.2-.2m.4.4h-1c0 .1 0 .2-.2.1m2.5.8-1.5.2m.5.5c.5-.2 1-.2 1.6-.3m-.3 1.8.6-.1c.8-.2 1-.3 1.7-.3m.4.4-2 .2-.5.1m.5.3c.7 0 1.8 0 2.6-.2m.8.4c-.6.1-1.3 0-1.9.2l-1 .1m.7.5h.3c.6-.5 1.6-.4 2.5-.4m.5.4-1.9.1-1 .2m.7.4 1.6-.2h1.8m.2.3a4 4 0 0 0-1.4 0c-.3 0-.5.2-1.7.3m.5.2c.5 0 .9 0 1.3-.2h1.5m-2.3.5c.8 0 1-.2 1.8-.1l.8-.1m-15.9-10.7c.3-.1.2-.2.5-.2h.8m-1.8 0c.2-.2.3-.3.6-.3h.5c0-.1.2 0 .4 0m5.5 5.8c.2-.1.1-.2.5-.1-.1-.2.3 0 .4 0 0-.2.4-.1.5-.1m0 1.6 1.6-.4m.9.6c-.7.1-1.5 0-2 .2m-7.9-8.1a2.4 2.4 0 0 0-1.5.5m9.1 2.8 1-.2m-.7.4c.3 0 .8 0 1-.2m-.7.4h1.1m-.8.3 1.2-.1m.2.2-1 .2m.6.3.8-.2m.4.3-1 .1m.3.3c.3 0 1 0 1-.2m.5.4h-1m.3.4 1.1-.1m.4.2-1 .2m.3.3h1.2m.3.2h-1.1m2 .8-1.2.1m.4.3 1.3-.2m-.4 1.3h.6l1.4-.2m.3.3-1.6.2h-.4m.3.3 2.1-.2m.6.4h-1.4l-1 .1m.5.4.7-.1 1.7-.2m.4.3-1.4.1-1 .2m.6.3 1.3-.2h1.4m.2.2h-1.2c-.2.1-.4.2-1.3.3m.4.1 1-.1h1.2m-1.9.4c.6-.1.9-.2 1.6-.1h.6m-12.4-8.3c.2 0 .3-.2.5-.1h.4l.3-.1m-1.5 0c.2-.1.2-.2.5-.2h.7m4 4.4h.6c-.1-.2.3 0 .3-.1h.4m0 1.2c.4-.1.9-.1 1.3-.3m.6.5c-.5 0-1.2 0-1.6.2m-6-6.3c-.5 0-.6.2-.9.4m7.5 1 1-.2m-.7.4c.3 0 .8 0 1-.2m-.7.4h.7c0-.1.2 0 .2 0m-.6.4 1-.2m.3.2a3 3 0 0 0-1 .2m.3.3 1-.2m.4.3h-1m.3.3c.2 0 1 0 1-.2m.4.4h-1m.4.3h1m.3.1-1 .2m.5.3 1-.1m.3.3h-1m1.9.7-1.2.1m.3.3 1.3-.2m-.4 1.2h.6l1.2-.2m.3.3a13.4 13.4 0 0 1-1.4.2h-.4m.2.3a40.2 40.2 0 0 1 2-.2m.6.3h-1.4l-.8.2m.4.3h.6l1.6-.3m.4.3-1.3.1-1 .2m.6.3 1.2-.2h1.3m.2.2a3.4 3.4 0 0 0-1 0l-1.3.2m.4.1 1-.1h1m-1.7.4 1.4-.1h.5m-11.3-7.7c.1 0 .2-.1.4 0l.4-.1h.2m-1.3 0 .4-.2h.4l.3-.1m3.7 4.2.5-.1h.6m0 1c.3 0 .9 0 1.2-.2m.6.4c-.5 0-1.2 0-1.6.2m-5.4-5.8c-.4 0-.6.2-.8.4"
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    fill: "#fc0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m221.5 318.5.6 4.8c-1.3-.5-2.4.3-3 1.3-.9 1.8 0 3.1 1.6 4l2.3 1.2 4.3-8.3-1.7-.9-1.7 3.3-.4-4.4-2-1zm.6 6.3.9.3h.2l-1.2 2.3h-.2c-.8-.5-1.3-1-.9-1.9.3-.6.7-.8 1.2-.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "m214.7 325.2-4.1-2.8.9-1.3 2.5 1.7 1.2-1.7-2.5-1.6.9-1.3 2.4 1.7 1.4-2.1-2.5-1.8.8-1.3 4.2 2.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m212.3 312-2.2 2.6-.7-.6c-1.5-1.3-3-1.2-4.3.3-1.4 1.6-.9 3 .7 4.3l2 1.7 6-7-1.5-1.3zm-4.7 3c.4 0 .7.3 1 .6l.4.2-1.7 2-.3-.3c-.7-.6-1-1.1-.4-2 .4-.4.7-.5 1-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "m200.9 314.3-1.3-1.5 3.9-3.5c.9-.7 2-1.9 1-3-1.1-1.3-2.4-.3-3.3.5l-3.8 3.5-1.3-1.4 4.1-3.7c1.7-1.5 3.6-2 5.4 0 1.7 1.9 1.1 3.8-.6 5.3l-4 3.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.5 296.7a2.5 2.5 0 0 0-1.7.5c-.8.5-1.4 1.6-1 2.7-.6-.3-1.3-.1-1.9.3-1.5 1-1.5 2.3-.5 3.8l1.4 2 7.7-5.3-1.7-2.5c-.6-.9-1.4-1.5-2.3-1.5zm0 2c.5 0 1 .4 1.3 1l.3.2-2 1.4-.2-.3c-.4-.7-1-1.5 0-2.1.2-.2.4-.2.6-.2zm-2.8 2.7c.4 0 .7.2 1 .6v.2l-1.7 1.2-.2-.1c-.4-.6-.5-1.2.3-1.7.2-.2.4-.2.7-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "m194.6 292.8-1.2-2.4 1.3-.7 2.2 4-8.2 4.4-.9-1.7zm-10-2.9 8.6-3.7.8 1.7-8.6 3.8zm-1-10.2a2.9 2.9 0 0 0-.2 2.4c.6 1.7 2.4 2.2 4 1.7 1.4-.5 2.5-2 2-3.7a3 3 0 0 0-1.6-1.7l2-.7c.6.6 1 1.2 1.3 2a4.8 4.8 0 0 1-3.1 6c-2.6.7-5.4-.4-6.3-3a5 5 0 0 1-.1-2.3l2-.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m188.1 267.3-8.7 5.3.2 1.5 10 2-.3-2-2-.4-.7-3.3 1.9-1.1-.4-2zm-2.8 3.9.4 2.2-3.5-.4 3-1.8zm-2.1-21.3a4.4 4.4 0 0 0-4.5 4.3l-.2 2.7 9.2.8.3-2.7a4.5 4.5 0 0 0-4.3-5h-.5zm-.3 2.2h.6c1.7 0 2.7 1 2.5 3.1v.3l-5.5-.5v-.3c.1-1.7 1-2.5 2.3-2.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "m179.6 246.3 1-4.9 1.6.4-.7 3 2 .4.7-3 1.5.4-.6 3 2.5.5.6-3 1.5.2-1 5zm3.3-12.5 1.9-4.7 1.5.6-1.2 2.9 1.9.7 1-2.8 1.6.6-1.1 2.8 2.3 1 1.1-3 1.5.6-1.8 4.6zm11-6 1.3-2.4 1.4.7-2.1 4.1-8.3-4.3.9-1.6zm2.6-14.6a2 2 0 0 0-1.4.7c-.4.5-.4 1.2 0 1.6 1.3 1 3.1-2.5 5.6-.7 1.5 1.2 1.8 2.9.7 4.5-.8 1-2 1.4-3.3 1.3l-.2-1.7c.8.2 1.7.1 2.2-.6.4-.6.2-1.3-.4-1.8-.8-.5-1.5 0-2.2.5-1.1.7-2.1 1-3.3.2a2.8 2.8 0 0 1-.6-4c.5-.6 1.6-1.3 2.4-1.4l.5 1.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m200.7 205-1 1.1 4.2 9.4 1.4-1.5-.9-1.9 2.4-2.4 1.9.8 1.4-1.4-9.4-4zm1.5 2.7 3 1.4-1.5 1.5-1.6-2.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "m212 205.6 2-1.7 1 1.2-3.5 2.9-5.9-7.3 1.5-1.1zm6-13.6 2 10.1-1 .6-8.2-6 1.7-1.2 5.3 4-1.5-6.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m224.6 188.6-1.3.6.5 10.3 1.8-.8v-2.2l3-1.4 1.4 1.5 1.9-.8-7.3-7.2zm.4 3 2.3 2.4-2 .8-.3-3.1zm10-6.2c-.5 0-1 0-1.5.2l-2.5.8 2.6 8.9 2.5-.8a4.5 4.5 0 0 0 3.2-5.7c-.6-2.1-2.2-3.4-4.3-3.4zm0 2c1.1 0 1.9.6 2.3 2 .5 1.6 0 2.9-2 3.5h-.3l-1.6-5.3.3-.1 1.3-.2zm11.2-4.7h-.5a4.7 4.7 0 0 0-4.1 5.5 4.7 4.7 0 0 0 5.4 4.2 4.8 4.8 0 0 0 4-5.5 4.8 4.8 0 0 0-4.8-4.2zm-.2 2c1.4-.1 2.7 1 2.9 2.5.1 1.2-.8 3-2.2 3.2-1.5.2-2.8-1.3-3-2.6-.1-1.3.7-2.9 2.3-3zm7.9-2.5-.1 9.3h1.9v-3.7l2.3 3.8h2.3l-2.7-4c1.3-.1 2-1.3 2-2.5 0-2-1.3-2.8-3.2-2.8H254zm2 1.7h.2c.9 0 1.6.2 1.5 1.3 0 1-.6 1.3-1.6 1.3h-.2v-2.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "m272.2 184 4.9 1.2-.4 1.6-3-.8-.5 2 2.9.7-.4 1.5-3-.7-.5 2.4 3 .8-.4 1.5-4.9-1.2zm9 5.7-2.3 5.9-1.7-.7 3.5-8.9 1.3.5 2.3 8 2.4-5.9 1.7.7-3.5 8.8-1.3-.5-2.3-7.9zm12 11.1 2.2 1.4-.9 1.4-3.8-2.4 5-8 1.5 1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m304.4 199-9 5 1.6 1.3 1.8-1 2.6 2.1-.6 2 1.5 1.3 3.2-9.7-1.1-1zm-1.4 2.7-1 3.1-1.7-1.3 2.7-1.8zm15.3 11.9-9.9 2.5 1.2 1.6 2-.5 2 2.7-1.1 1.8 1.1 1.7 5.6-8.6-.9-1.2zm-2 2.2-1.8 2.8-1.2-1.8 3-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "m323 228.7-6.3.6-.3-.5 4.3-4.6-5.6 1.8-.8-1.7 9.2-2.8.7 1.2-4.4 4.8 6.4-.7.7 1.3-8 5.6-.8-1.7 4.8-3.3zm5.4 3.9 1.6 4.7-1.5.5-1-3-2 .7 1 2.9-1.5.5-1-2.9-2.3.8 1 3-1.5.5-1.6-4.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m331 240.8-9.1 1.9.3 1.8 3.7-.7-3.1 3 .5 2.3 3.2-3.5c.5 1.3 1.8 1.7 3 1.4 1.9-.4 2.4-1.8 2-3.7l-.6-2.5zm-1.2 2.2v.2c.2 1 .2 1.7-.9 1.9-1 .2-1.4-.4-1.5-1.3v-.3l2.4-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "m332.9 251.8-9.3 1-.2-1.8 9.2-1zm-2 10c.6-.5.9-1.3.9-2.1 0-1.8-1.7-2.8-3.3-2.8-1.5 0-3 1.1-3 2.9 0 .8.4 1.6 1 2.1h-2.2a5 5 0 0 1-.6-2.1 4.8 4.8 0 0 1 4.8-4.9c2.6 0 5 1.9 5 4.7a4.7 4.7 0 0 1-.5 2.2h-2.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m324 263.6-.2 2 1.8 1-.4 3.3-2 .5-.3 2 10-2.5.1-1.4-9-5zm3 3.8 3 1.3-3.2.8.3-2.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M324.3 290.3a3 3 0 0 0 1.7-1.7c.7-1.7-.4-3.2-2-3.8-1.4-.6-3.2-.2-3.9 1.5a3 3 0 0 0 .2 2.3l-2-.7c-.1-.8 0-1.6.2-2.3a4.8 4.8 0 0 1 6.2-2.6c2.5 1 4 3.6 3 6.2a5 5 0 0 1-1.4 1.9l-2-.8zm.8 4-2.4 4.5-1.4-.8 1.5-2.7-1.8-1-1.5 2.6-1.3-.7 1.4-2.6-2.2-1.3-1.5 2.8-1.4-.8 2.4-4.4zm-7.8 7.4-5.1-3.7 1-1.5 7.8 5.6-.8 1.1-8.3.3 5 3.7-1 1.5-7.7-5.6.8-1 8.2-.4zm-4.6 8.3 1 1-4 4.2-1-1 1.3-1.5-5.6-5.3 1.3-1.4 5.6 5.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m301.7 310.1-1.5 1.2 2.4 2.9-4.2-1.3-1.8 1.4 4.6 1.3c-.8 1-.6 2.3.2 3.2 1.2 1.5 2.8 1.3 4.3 0l1.9-1.6-6-7zm1.8 5.2 1.6 2-.2.1c-.7.6-1.3.9-2 .1s-.3-1.4.4-2l.2-.2zm-7.6-.4-1.7 1.1.3 2-2.8 1.8-1.7-1.2-1.7 1 8.2 6.2 1.2-.7-1.8-10.2zm-1.1 5 .8 3-2.6-2 1.8-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "m285.7 322.6-2.5 1.1-.7-1.4 4.2-2 4 8.5-1.7.8z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSv);
export default __webpack_public_path__ + "static/media/sv.dd3c991c109acb5525b19cf667bb630a.svg";
export { ForwardRef as ReactComponent };